import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';

import { setCookie, getCookie } from '../utils/cookie_utils.js'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import '../css/SolutionPage.css';

class SolutionPage extends Component {
  constructor(props) {
    var lang = "zh"
    if (getCookie("lang") !== "") {
      lang = getCookie("lang")
    }

    super(props);
    this.state = {
      lang: lang,
      card_display: "v2_display_none",
      current_cat: "id1",
      category: {
        "title": {"zh": "方案類別 >", "en": "Categories >", "ja": "カテゴリ >"},
        "content": [
          {"id": "id1", "zh": "總覽", "en": "Overview", "ja": "概要"},
          {"id": "id2", "zh": "AI智慧停車", "en": "AI Smart Parking", "ja": "AI駐車場"},
          {"id": "id3", "zh": "AI智慧保全", "en": "AI Smart Security", "ja": "AIセキュリティ"},
          {"id": "id4", "zh": "AI設施管理", "en": "AI Facility Management", "ja": "AI施設管理"},
          {"id": "id5", "zh": "AI工廠自動化", "en": "AI Factory Automation", "ja": "AI工場"},
          {"id": "id6", "zh": "技術服務", "en": "Technical Services", "ja": "技術サービス"}
        ]
      },
      card_content: null,


      content: [
        {
          "title": {"zh": "AI智慧停車", "en": "AI Smart Parking", "ja": "AI駐車場", "color": "#69E1F5", "group_tag": ["id1", "id2"]},
          "content": [{
            "zh": "車牌辨識停車管理",
            "en": "LPR-based Parking Management System",
            "ja": "ナンバープレート認識駐車管理",
            "group_tag": ["id1", "id2"],
            "img_url": "/assets/solution/A1.jpg",
            "detail_content": {
                "zh": {
                    "title": "車牌辨識停車管理",
                    "subt1": "適用場域",
                    "subl1": ["室內停車場", "室外停車場", "社區停車場", "商業大樓停車場"],
                    "subt2": "使用技術",
                    "subl2": ["深度機器學習", "車牌辨識技術", "多元支付", "遠端網頁管理系統"],
                    "subt3": "現有痛點",
                    "subc3": "現有的停車管理系統依賴人力管理，效率低下且易出錯。車牌辨識系統有時會出現辨識卡頓現象，影響使用者體驗。此外，現有系統缺乏統一的數據分析和管理功能，難以進行全面的停車場管理和運營優化。",
                    "subt4": "方案說明",
                    "subc4": "Nexuni為停車場業者研發了一款智慧有效率的車牌辨識停車管理系統，不僅大幅減輕人力管理負擔，還通過科技化設備提供更多數據供分析管理使用。該系統架構簡單，易於安裝，採用深度機器學習技術，具備高度準確的車牌辨識能力和高容錯能力，避免辨識卡頓現象。系統支持完整的電子支付和電子發票功能，並提供遠端網頁管理系統。核心技術為強大且準確的AI車牌辨識科技，系統可選擇包含停車引導系統、自動化收款機器、線上繳停車費等功能，全面提升停車場管理效率和用戶體驗。<br/><br/>1. 99.5%車牌辨識準確率<br/>2. 150毫秒辨識時間<br/>3. 利用AI持續學習"
                },
                "en": {
                    "title": "LPR-based Parking Management System",
                    "subt1": "Applicable Areas",
                    "subl1": ["Indoor Parking Lots", "Outdoor Parking Lots", "Apartment Parking Lots", "Commercial Building Parking Lots"],
                    "subt2": "Technologies",
                    "subl2": ["Deep Learning", "License Plate Recognition", "Electronic Payments", "Remote Web Management System", "Electronic Invoicing"],
                    "subt3": "Current Issues",
                    "subc3": "Current parking systems are inefficient due to manual management and prone to errors. License plate recognition systems may lag, impacting user experience. Furthermore, they lack unified data analysis and management, complicating parking lot management and optimization.",
                    "subt4": "Solution Description",
                    "subc4": "Nexuni offers a versatile parking solution, transforming any space into a lot. Our smart license plate recognition system streamlines manual management and enhances data analysis capabilities. With a simple setup and deep machine learning technology, it ensures accurate recognition and minimal lag. Features include electronic payment, remote management, and AI-powered functions like parking guidance. This boosts efficiency and user satisfaction, making parking management seamless.<br><br>1. 99.5% license plate recognition accuracy<br>2. 150 ms recognition time<br>3. Continuous learning with AI"
                },
                "ja": {
                    "title": "ナンバープレート認識駐車管理",
                    "subt1": "適用範囲",
                    "subl1": ["屋内駐車場", "屋外駐車場", "コミュニティ駐車場", "商業ビル駐車場"],
                    "subt2": "使用技術",
                    "subl2": ["深層学習", "ナンバープレート認識技術", "電子決済", "リモートウェブ管理システム"],
                    "subt3": "現行の課題",
                    "subc3": "現在の駐車管理システムは人力管理に依存しており、効率が悪く、エラーが発生しやすいです。ナンバープレート認識システムは時折認識遅延が発生し、ユーザー体験に影響を与えることがあります。さらに、現行のシステムは統一されたデータ分析および管理機能が欠如しており、包括的な駐車場管理および運営の最適化が難しいです。",
                    "subt4": "ソリューション説明",
                    "subc4": "Nexuniは駐車場業者向けに、ナンバープレート認識駐車管理システムを開発しました。このシステムは、人力管理の負担を大幅に軽減するだけでなく、技術的な装置を通じて分析管理用のデータを提供します。システムのアーキテクチャはシンプルで、インストールが簡単です。深層学習技術を採用し、高精度のナンバープレート認識能力と高いフォールトトレランスを提供し、認識遅延を回避します。システムは完全な電子決済および電子請求書機能をサポートし、リモートウェブ管理システムを提供します。コア技術は強力かつ正確なAIナンバープレート認識技術であり、システムは駐車ガイダンスシステム、自動支払機、オンライン駐車料金支払いなどの機能をオプションで含めることができ、駐車場管理の効率とユーザー体験を大幅に向上させます。<br/><br/>1. 99.5%のナンバープレート認識精度<br/>2. 150ミリ秒の認識時間<br/>3. AIによる継続的な学習"
                }
            }
        },
         {
            "zh": "ETag停車管理",
            "en": "ETag-based Parking Management System",
            "ja": "ETag駐車管理",
            "group_tag": ["id1", "id2"],
            "img_url": "/assets/solution/A2.jpg",
            "detail_content": {
                "zh": {
                    "title": "ETag停車管理",
                    "subt1": "適用場域",
                    "subl1": ["室內停車場", "室外停車場", "社區停車場", "商業大樓停車場"],
                    "subt2": "使用技術",
                    "subl2": ["無線射頻識別", "完整Etag停車設備", "多元支付整合", "遠端網頁管理系統"],
                    "subt3": "現有痛點",
                    "subc3": "若安裝之場域有隱私等因素，如軍營等，而無法安裝攝影機來進行停車管理，則需要有另一種非影像的車輛辨識方法來進行停車管理。",
                    "subt4": "方案說明",
                    "subc4": "Nexuni 提出的 ETag 停車管理系統適用於室內外停車場、社區停車場及商業大樓等場域。系統整合了 ETag 無線射頻識別、完整停車場設備、電子支付技術、電子發票技術及遠端網頁管理系統，為客戶提供完整的 ETag 停車管理解決方案。無線識別技術可提供穩定的車輛 ETag 辨識，多元電子支付則為停車用戶提供了便捷且高效的付款方式。Nexuni 團隊在新加坡及台灣成功部署了超過 1000 個系統，具有豐富經驗。"
                },
                "en": {
                    "title": "ETag-based Parking Management System",
                    "subt1": "Applicable Areas",
                    "subl1": ["Indoor Parking Lots", "Outdoor Parking Lots", "Community Parking Lots", "Commercial Building Parking Lots"],
                    "subt2": "Technologies",
                    "subl2": ["RFID", "Complete ETag Parking Equipment", "Electronic Payments", "Remote Web Management System"],
                    "subt3": "Current Issues",
                    "subc3": "In environments where privacy concerns, such as military bases, prevent the installation of cameras for parking management, there is a need for an alternative, non-image-based vehicle recognition method for parking management.",
                    "subt4": "Solution Description",
                    "subc4": "Nexuni's ETag Parking Management System works for indoor and outdoor lots, community areas, and commercial buildings. It uses ETag RFID technology, along with various equipment, electronic payment, invoicing, and remote management. It ensures stable vehicle recognition and offers convenient payment options. With over 1,000 successful deployments in Singapore and Taiwan, Nexuni proves its expertise in the field."
                },
                "ja": {
                    "title": "ETag駐車管理",
                    "subt1": "適用範囲",
                    "subl1": ["屋内駐車場", "屋外駐車場", "コミュニティ駐車場", "商業ビル駐車場"],
                    "subt2": "使用技術",
                    "subl2": ["無線周波数識別", "完全なETag駐車設備", "電子決済", "リモートWeb管理システム"],
                    "subt3": "現行の課題",
                    "subc3": "プライバシーの問題がある地域、例えば軍基地などでカメラを設置できない場合、非画像による車両識別方法が必要です。",
                    "subt4": "ソリューション説明",
                    "subc4": "NexuniのETag駐車管理システムは、屋内外の駐車場、コミュニティ駐車場、商業ビルなどに適しています。システムはETag無線周波数識別、完全な駐車場設備、電子決済技術、電子請求書技術、およびリモートWeb管理システムを統合し、顧客に完全なETag駐車管理ソリューションを提供します。無線識別技術は安定した車両ETag識別を提供し、複数の電子支払いは駐車ユーザーに便利で効率的な支払い方法を提供します。Nexuniはシンガポールと台湾で1,000を超えるシステムを成功裏に展開し、豊富な経験を積んでいます。"
                }
            }
        },

          {
            "zh": "微型停車管理系統",
            "en": "Micro Parking Management System",
            "ja": "マイクロ駐車管理システム",
            "group_tag": ["id1", "id2"],
            "img_url": "/assets/solution/A3.jpg",
            "detail_content": {
                "zh": {
                    "title": "微型停車管理系統",
                    "subt1": "適用場域",
                    "subl1": ["公寓大樓", "小型場域"],
                    "subt2": "使用技術",
                    "subl2": ["微型機器學習", "車牌辨識技術", "電子支付技術", "遠端網頁管理系統"],
                    "subt3": "現有痛點",
                    "subc3": "現有停車場安裝設備的過程相當繁瑣，不僅需要專業人員進行安裝，還涉及到大量的施工和調試工作，導致操作和管理的靈活性大大降低。此外，為達成到快速車牌辨識系統需使用昂貴設備來達成，使得停車場運營成本增加，對於短期場地管理來說，更是顯得得不償失。",
                    "subt4": "方案說明",
                    "subc4": "此系統使用嵌入式智慧攝影機，並結合NXAI框架進行車牌辨識，以取代傳統硬體設備。它具有高度整合架構，提供開方式接口，可方便地DIY安裝。機器學習車牌辨識技術可達到99.5%的準確度，體積小且擴充性高，適用於各種停車需求。此系統支援多種支付系統，並且具有遠端網頁管理系統。"
                },
                "en": {
                    "title": "Micro Parking Management System",
                    "subt1": "Applicable Areas",
                    "subl1": ["Apartment Buildings", "Small Area of Land"],
                    "subt2": "Technologies",
                    "subl2": ["Micro Machine Learning", "License Plate Recognition", "Electronic Payments", "Remote Web Management System"],
                    "subt3": "Current Issues",
                    "subc3": "Installing existing parking lot equipment is labor-intensive, involving professional installation, construction, and calibration. This reduces flexibility in operations and management. Moreover, fast license plate recognition systems often demand pricey equipment, escalating operational costs. This poses challenges for short-term parking management, causing economic strain and limiting adaptability to market fluctuations.",
                    "subt4": "Solution Description",
                    "subc4": "This system utilizes embedded smart cameras and the NXAI framework for license plate recognition, replacing traditional hardware. It boasts a highly integrated architecture with open interfaces, enabling simple DIY installation. With machine learning technology, it achieves 99.5% accuracy, is compact, and easily scalable for diverse parking requirements. Supporting multiple payment systems and featuring a remote web management system, it enhances flexibility and efficiency in parking lot management."
                },
                "ja": {
                    "title": "マイクロ駐車管理システム",
                    "subt1": "適用範囲",
                    "subl1": ["マンション", "小規模エリア"],
                    "subt2": "使用技術",
                    "subl2": ["マイクロ機械学習", "ナンバープレート認識技術", "電子決済技術", "リモートWeb管理システム"],
                    "subt3": "現行の課題",
                    "subc3": "現在の駐車場機器の設置プロセスは非常に煩雑で、専門家の設置が必要であり、大量の施工と調整作業が伴い、操作と管理の柔軟性が大幅に低下します。さらに、高速ナンバープレート認識システムを実現するためには高価な機器が必要であり、運営コストが増加し、短期的なサイト管理には不適切です。",
                    "subt4": "ソリューション説明",
                    "subc4": "このシステムは、組み込みスマートカメラとNXAIフレームワークを使用してナンバープレート認識を行い、従来のハードウェア機器を置き換えます。高度に統合されたアーキテクチャを特徴とし、オープンインターフェースを提供してDIYインストールを容易にします。機械学習ナンバープレート認識技術は99.5%の精度を達成します。コンパクトで拡張性が高く、さまざまな駐車ニーズに適しています。このシステムは複数の支払いシステムをサポートし、リモートWeb管理システムを備えています。"
                }
            }
        },

         {
            "zh": "電動車充電樁",
            "en": "EV Charging Stations",
            "ja": "電気自動車充電スタンド",
            "group_tag": ["id1", "id2"],
            "img_url": "/assets/solution/A4.jpg",
            "detail_content": {
                "zh": {
                    "title": "電動車充電樁",
                    "subt1": "適用場域",
                    "subl1": ["室內停車場", "室外停車場", "社區停車場", "商業大樓停車場"],
                    "subt2": "使用技術",
                    "subl2": ["深度機器學習", "車牌辨識技術", "電源附載動態分配", "儲能系統"],
                    "subt3": "現有痛點",
                    "subc3": "電動車充電樁在實際應用中面臨多重挑戰。首先，許多車輛在充電完成後長時間佔用充電樁，導致其他需要充電的車輛無法使用。其次，全球淨零轉型要求降低碳排放並提高能源使用效率，需要減少對傳統發電機組的依賴，優化可再生能源的發電功率。",
                    "subt4": "方案說明",
                    "subc4": "我們將在每個充電樁上安裝嵌入式系統和攝影機，確保只有在確認車輛停放後才能啟動充電。如果車輛長時間佔用充電車位而不充電，系統將自動收取佔用費，以此達到嚇阻作用。利用即時電網使用情況，動態調整充電樁的負載，平衡電網負荷。根據不同比例電力供應情況，實行時段性收費，鼓勵車主在電力供應充足時段進行充電。所有設備將記錄充電使用趨勢，並整合出詳細報告，為後續的系統調整和優化提供數據支持。開放API，允許不同設備接入使用，實現多方協同和統一管理，結合多元支付方式，優化使用者體驗和便利性，確保用戶可以使用多種支付方式進行充電付費。"
                },
                "en": {
                    "title": "EV Charging Stations",
                    "subt1": "Applicable Areas",
                    "subl1": ["Indoor Parking Lots", "Outdoor Parking Lots", "Community Parking Lots", "Commercial Building Parking Lots"],
                    "subt2": "Technologies",
                    "subl2": ["Deep Learning", "License Plate Recognition", "Dynamic Load Distribution", "Energy Storage System","Electronic payment"],
                    "subt3": "Current Issues",
                    "subc3": "EV charging stations face challenges such as occupancy issues, hindering access, and reducing efficiency. The shift to net-zero emissions demands optimized renewable energy usage, but volatility and concentrated charging strain the grid, necessitating effective load management. Existing technology struggles to detect occupancy issues automatically, relying on manual oversight, while payment systems are complex and inconsistent. Addressing these challenges requires intelligent management, central server coordination, energy storage, and dynamic pricing to enhance efficiency and support the net-zero transition.",
                    "subt4": "Solution Description",
                    "subc4": "Our solution involves installing embedded systems and cameras on each charging station to activate charging upon vehicle parking confirmation. Occupancy fees deter non-charging vehicles. Using real-time grid data, the system adjusts station loads dynamically, balancing supply and demand. Time-based pricing encourages off-peak charging. Detailed reports inform system adjustments. Open APIs facilitate device integration for collaborative management. Multiple payment methods enhance user experience. Energy storage integration optimizes grid efficiency and reduces peak loads."
                },
                "ja": {
                    "title": "電気自動車充電スタンド",
                    "subt1": "適用範囲",
                    "subl1": ["屋内駐車場", "屋外駐車場", "コミュニティ駐車場", "商業ビル駐車場"],
                    "subt2": "使用技術",
                    "subl2": ["深層学習", "ナンバープレート認識技術", "電源負荷の動的配分", "エネルギー貯蔵システム"],
                    "subt3": "現行の課題",
                    "subc3": "電気自動車の充電スタンドは、実際の使用において多くの課題に直面しています。まず、多くの車両が充電完了後に長時間充電スタンドを占有し、他の車両が使用できなくなります。次に、地球規模でのネットゼロ移行は、炭素排出量を削減し、エネルギー効率を向上させる必要があり、再生可能エネルギーの発電を最適化する必要があります。",
                    "subt4": "ソリューション説明",
                    "subc4": "各充電スタンドに埋め込みシステムとカメラを設置し、車両が駐車確認後にのみ充電を開始することを保証します。充電せずに長時間充電場所を占有している場合、システムは自動的に占有料金を請求し、そのような行為を抑止します。リアルタイムの電力網使用状況を利用して、充電スタンドの負荷を動的に調整し、電力網の負荷をバランスさせます。異なる電力供給条件に基づいて時限料金を実施し、電力供給が充実している時間帯に充電を促します。すべての機器は充電使用傾向を記録し、詳細なレポートを統合して、後続のシステム調整と最適化のためのデータサポートを提供します。APIを公開して、さまざまなデバイスの統合を許可し、協調的かつ統一された管理を実現し、複数の支払い方法を組み合わせてユーザーエクスペリエンスと利便性を最適化し、ユーザーがさまざまな方法で充電料金を支払うことを保証します。"
                }
            }
        },

         {
            "zh": "車位在席偵測",
            "en": "Parking Guidance System (PGS)",
            "ja": "駐車スペース占有検知",
            "group_tag": ["id1", "id2"],
            "img_url": "/assets/solution/A5.jpg",
            "detail_content": {
                "zh": {
                    "title": "車位在席偵測",
                    "subt1": "適用場域",
                    "subl1": ["地下停車場", "室內停車場", "購物中心停車場", "機車停車場"],
                    "subt2": "使用技術",
                    "subl2": ["車牌辨識", "車輛追蹤"],
                    "subt3": "現有痛點",
                    "subc3": "傳統的車位導引系統 (PGS)多透過超音波、紅外線等技術去判斷車輛是否在車位中。此方法常常會導致誤差並使停車場管理錯估實際的車位數量，進而降低車位導引的準確度。",
                    "subt4": "方案說明",
                    "subc4": "Nexuni提出的智慧車位導引系統 (VPGS)使用影像並將NXAI框架套用在微處理器上，體積小且安裝方便，使用車牌辨識模型進行邊緣運算，可準確的判斷車位在席狀態，且可提供更多影像資料進行停車場管理分析。 智慧車位導引系統 (VPGS)不僅安裝方便，而且車牌識別率高，能準確顯示即時停車位狀態，同時還可升級加入智慧尋車功能。VPGS硬體簡單，成本低廉，無需額外的線槽，一條電線即可處理一排設備，僅需兩顆螺絲即可安裝。"
                },
                "en": {
                    "title": "Parking Guidance System (PGS)",
                    "subt1": "Applicable Areas",
                    "subl1": ["Underground Parking Lots", "Indoor Parking Lots", "Shopping Center Parking Lots", "Motorcycle Parking Lots"],
                    "subt2": "Technologies",
                    "subl2": ["License Plate Recognition", "Vehicle Tracking"],
                    "subt3": "Current Issues",
                    "subc3": "Traditional Parking Guidance Systems (PGS) often use technologies like ultrasonic or infrared to determine whether vehicles are in parking spaces. This method frequently leads to errors and misjudgments by parking lot management, resulting in reduced accuracy of parking guidance.",
                    "subt4": "Solution Description",
                    "subc4": "Nexuni's Video-Based Parking Guidance System (VPGS) uses imagery and the NXAI framework on microprocessors. It's compact, easy to install, and employs a license plate recognition model for edge computing, enabling accurate occupancy status determination and rich image data for parking lot management analysis. With high license plate recognition rates, it offers real-time parking space status displays and can be upgraded for smart vehicle locating. Its simple, cost-effective hardware requires no extra cable trenches and installs easily with just two screws per row of devices."
                },
                "ja": {
                    "title": "駐車スペース占有検知",
                    "subt1": "適用範囲",
                    "subl1": ["地下駐車場", "屋内駐車場", "ショッピングセンター駐車場", "オートバイ駐車場"],
                    "subt2": "使用技術",
                    "subl2": ["ナンバープレート認識", "車両追跡"],
                    "subt3": "現行の課題",
                    "subc3": "従来の駐車誘導システム（PGS）は、超音波や赤外線などの技術を使用して車両が駐車スペースにいるかどうかを判断します。この方法は誤差が生じやすく、駐車場管理が実際の駐車スペース数を誤って見積もる原因となり、駐車誘導の精度が低下します。",
                    "subt4": "ソリューション説明",
                    "subc4": "Nexuniのスマート駐車誘導システム（VPGS）は、映像を使用し、NXAIフレームワークをマイクロプロセッサに適用します。コンパクトで設置が簡単で、ナンバープレート認識モデルを使用したエッジコンピューティングにより、駐車スペースの占有状態を正確に判断し、駐車場管理分析のための追加の映像データを提供します。VPGSは設置が簡単なだけでなく、ナンバープレート認識率が高く、リアルタイムの駐車スペース状況を正確に表示でき、スマートカー探索機能の追加も可能です。VPGSのハードウェアはシンプルで、コストも低く、追加の配線は不要で、一列の設備を単一のケーブルで処理でき、取り付けにはネジが2本だけで済みます。"
                }
            }
        },
                    {"zh": "AI數位孿生",
                    "en": "Digital Twin", 
                    "ja": "AIデジタルツイン",
                    "group_tag": ["id1", "id2"],
                    "img_url": "/assets/solution/A6.jpg", 
                    "detail_content": 
                        {"zh": {
                            "title": "AI數位孿生", 
                            "subt1": "適用場域",
                            "subl1": ["公共停車場", "大型購物中心","機場停車場","公司辦公大樓","醫療機構停車場","智慧城市"],
                            "subt2": "使用技術", 
                            "subl2": ["數位孿生技術","實時多串流處理","人工智慧 (AI)","物聯網 (IoT)","影像識別","邊緣運算"], 
                            "subt3": "現有痛點", 
                            "subc3": "現有的停車場管理系統多數依賴人工巡查和傳統的停車感測器，管理效率低且難以實時掌握停車場狀況。車輛進出高峰期易造成交通堵塞，車位利用率不佳，車主尋找車位困難且耗時。此外，缺乏即時數據分析和預測能力，難以進行有效的資源調度和管理。傳統地感線圈技術存在誤差，對於車輛進出記錄不準確，管理難度大。手動處理異常情況效率低，容易發生遺漏和錯誤。", 
                            "subt4": "方案說明", 
                            "subc4": "Nexuni的停車場AI數位孿生系統利用先進的數位孿生技術，結合人工智慧、物聯網和大數據分析，實現停車場的全面數位化管理。系統通過布設於停車場內的攝像頭和感測器，實時監控車輛進出和車位使用情況，並將數據傳輸至雲端處理和分析。<br><br>主要功能包括：<br><br>1. 異常情況偵測與預警：偵測跟車情況、卡在柵欄前的車輛及排隊預警，保障安全。<br>2. 多重感測校正：輔以影像車流計數校正地感線圈誤差，確保記錄準確。<br>3. 禁止停車區偵測：自動識別違規停車並發出警報，維持秩序。<br>4. 即時數據分析與預測：AI算法進行實時數據分析和預測，提供最佳停車位推薦，減少尋車時間。"
                    },
                                           
                    "en": {
                        "title": "Digital Twin", 
                        "subt1": "Applicable Areas", 
                        "subl1": ["Public Parking Lots","Large Shopping Centers","Airport Parking Lots","Corporate Office Buildings","Medical Institution Parking Lots","Smart Cities"], 
                        "subt2": "Technologies", 
                        "subl2": ["Digital Twin Technology", "Real-time Multi-stream Processing", "Artificial Intelligence (AI)", "Internet of Things (IoT)", "Image Recognition", "Edge Computing"], 
                        "subt3": "Current Issues", 
                        "subc3": "Current parking management systems heavily depend on manual patrols and traditional sensors, leading to low efficiency and challenges in real-time monitoring. Peak traffic times often result in congestion, poor space utilization, and difficulty in finding parking spots. Real-time data analysis and forecasting are lacking, making resource allocation and management difficult. Traditional ground loop technology is error-prone, causing inaccuracies in vehicle records, and manual handling of anomalies is inefficient and error-prone.", 
                        "subt4": "Solution Description", 
                        "subc4": "Nexuni's AI Digital Twin Parking System merges AI, IoT, and big data for comprehensive parking lot management. Cameras and sensors monitor real-time vehicle entry, exit, and space usage, with data sent to the cloud for processing. Features include anomaly detection, multi-sensor calibration, no-parking zone detection, and real-time analysis for congestion prediction and optimal parking recommendations. It aids resource allocation with virtual models, enhancing efficiency, space utilization, and driver satisfaction for intelligent parking management."
                    },
                    "ja": {
                        "title": "AIデジタルツイン", 
                        "subt1": "適用範囲", 
                        "subl1": ["公共駐車場", "大型購物中心", "機場駐車場", "公司辦公大樓", "醫療機構駐車場", "智慧城市"], 
                        "subt2": "使用技術", 
                        "subl2": ["デジタルツイン技術", "リアルタイムマルチストリーム処理", "人工知能（AI）", "インターネット・オブ・シングス（IoT）", "画像認識", "エッジコンピューティング"], 
                        "subt3": "現行の課題", 
                        "subc3": "現行の駐車場管理システムは、多くが人間による巡回と伝統的な駐車センサーに依存しており、管理効率が低く、駐車場の状況をリアルタイムで把握するのが難しい。車両の出入りがピーク時には交通渋滞が発生しやすく、駐車スペースの利用率が低く、駐車場の利用者は駐車スペースを見つけるのが困難で時間がかかる。さらに、リアルタイムデータ分析と予測能力が不足しており、効果的なリソースの配分と管理が難しい。伝統的な地感線技術は誤差があり、車両の出入り記録が正確でなく、管理が難しい。異常事態の手動処理は効率が低く、見落としやエラーが発生しやすい。", 
                        "subt4": "ソリューション説明", 
                        "subc4": "Nexuniの駐車場AIデジタルツインシステムは、先進のデジタルツイン技術を基盤に、人工知能、インターネット・オブ・シングス、ビッグデータ分析を組み合わせて、駐車場の包括的なデジタル管理を実現しています。システムは、駐車場内に設置されたカメラとセンサーによって車両の出入りと駐車スペースの利用状況をリアルタイムで監視し、これらのデータをクラウドに送信して処理と分析を行います。主な機能には、以下が含まれます：異常検知と警告：システムは、出入り口に車両がついているかどうか、車両がバリアに異常に詰まっているか、および待機車両の警告を自動的に検出し、駐車場の安全を確保します。マルチセンサー校正：伝統的な地感線技術の誤差を補正するために、システムは画像車流カウントを補助として使用し、車両の出入り記録の正確性を確保します。禁止駐車エリアの検出：システムは、禁止されている駐車エリアの違反行為を自動的に識別し、適時に警告を発し、駐車場の秩序を維持します。リアルタイムデータ分析と予測：AIアルゴリズムによるリアルタイムデータ分析と予測により、潜在的な交通渋滞問題を事前に発見し、駐車スペースの最適な推奨を提供し、駐車場の利用者が駐車スペースを見つける時間と労力を減らします。Nexuniシステムは駐車場の仮想モデルを生成し、リアルタイムの視覚化データを提供し、管理者が駐車場の状況を即座に把握し、効果的なリソースの配分を行うのを支援します。このシステムは、駐車場の管理効率を向上させるだけでなく、駐車スペースの利用率と利用者満足度を向上させ、駐車場管理のスマート化と自動化を実現します。"
                        }
                    }
             },

          {
              "zh": "自動繳費機",
              "en": "Automatic Payment Machine",
              "ja": "自動支払機",
              "group_tag": ["id1", "id2"],
              "img_url": "/assets/solution/A7.jpg",
              "detail_content": {
                  "zh": {
                      "title": "自動繳費機",
                      "subt1": "適用場域",
                      "subl1": ["汽車停車場", "機車停車場"],
                      "subt2": "使用技術",
                      "subl2": ["大數據分析", "多元支付整合", "GUI使用介面"],
                      "subt3": "現有痛點",
                      "subc3": "現有支付系統效率低、易出錯，增加了排隊時間和人力成本，且用戶體驗差、隱私保護不足。此外，財務管理困難，數據易錯。在疫情期間，傳統支付方式增加了病毒傳播風險，不利於公共衛生安全。",
                      "subt4": "方案說明",
                      "subc4": "我們設計的停車場自動繳費機目標是要能通過提升支付效率、降低人力成本和改善用戶體驗來優化停車場管理。自動繳費機可縮短排隊時間並快速處理現金、信用卡、Line Pay、悠遊卡等多種支付方式，且24小時運作，大大提高了服務效率。同時，設備減少了人工操作錯誤，提升用戶支付體驗和隱私保護。"
                  },
                  "en": {
                      "title": "Automatic Payment Machine",
                      "subt1": "Applicable Areas",
                      "subl1": ["Car Parking Lots", "Motorcycle Parking Lots"],
                      "subt2": "Technologies",
                      "subl2": ["Big Data Analysis", "Multiple Payment Integration", "Graphical user interface (GUI)"],
                      "subt3": "Current Issues",
                      "subc3": "Existing payment systems are inefficient, error-prone, and increase queuing times and labor costs, while also providing a poor user experience and inadequate privacy protection. Additionally, financial management is challenging, and data is prone to errors. During the pandemic, traditional payment methods have increased the risk of virus transmission, posing a threat to public health safety.",
                      "subt4": "Solution Description",
                      "subc4": "Our designed automatic payment machine for parking lots aims to optimize parking lot management by improving payment efficiency, reducing labor costs, and enhancing user experience. The automatic payment machine shortens queuing times and processes cash, credit cards, Line Pay, EasyCard, and other payment methods swiftly. Operating 24 hours a day significantly improves service efficiency. Moreover, the equipment reduces human errors, enhances user payment experience, and ensures privacy protection."
                  },
                  "ja": {
                      "title": "自動支払機",
                      "subt1": "適用範囲",
                      "subl1": ["自動車駐車場", "オートバイ駐車場"],
                      "subt2": "使用技術",
                      "subl2": ["ビッグデータ分析", "複数の支払い統合", "GUIインターフェース"],
                      "subt3": "現行の課題",
                      "subc3": "現行の支払いシステムは効率が悪く、エラーが発生しやすく、待ち時間や労働コストが増加し、ユーザー体験が悪く、プライバシー保護が不十分です。また、財務管理が難しく、データにエラーが発生しやすいです。パンデミック中、従来の支払い方法はウイルスの伝播リスクを増加させ、公衆衛生の安全性を損ないます。",
                      "subt4": "ソリューション説明",
                      "subc4": "私たちが設計した駐車場用の自動支払機は、支払い効率の向上、労働コストの削減、ユーザー体験の向上を通じて駐車場管理を最適化することを目的としています。自動支払機は待ち時間を短縮し、現金、クレジットカード、Line Pay、EasyCardなどの複数の支払い方法を迅速に処理でき、24時間稼働してサービス効率を大幅に向上させます。同時に、機器は手動操作エラーを減らし、ユーザーの支払い体験とプライバシー保護を向上させます。"
                  }
              }
          },

           {
              "zh": "停車管理中控中心",
              "en": "Parking Management Control Center",
              "ja": "駐車管理コントロールセンター",
              "group_tag": ["id1", "id2"],
              "img_url": "/assets/solution/A8.jpg",
              "detail_content": {
                  "zh": {
                      "title": "停車管理中控中心",
                      "subt1": "適用場域",
                      "subl1": ["停車塔", "地下停車場", "室內停車場", "購物中心停車場", "機車停車場"],
                      "subt2": "使用技術",
                      "subl2": ["雲端伺服器", "戰情室建置", "遠端控制"],
                      "subt3": "現有痛點",
                      "subc3": "缺乏後端管理軟體的停車場面臨多重痛點。首先，人工管理效率低，月票登記易出錯且費時，現場管理增加人力成本和複雜性。其次，設備維護不及時，需人工定期檢查，故障處理滯後，影響用戶體驗。第三，數據管理和分析不足，無法即時掌握停車場使用情況，數據分析困難，影響決策。第四，客戶體驗差，無法提供自動化繳費和電子票據，服務質量不穩定，影響車主滿意度。最後，營運成本高，大量人工管理、設備維護和數據處理增加了成本和難度，削弱競爭力。",
                      "subt4": "方案說明",
                      "subc4": "大多數停車場雖無現場工作人員，但後端仍需追蹤許多現場狀況。月票登記、設備管理多由人力完成。Nexuni 提供後端管理軟體，幫助停車場營運，根據需求客製化，提升管理效率和精確度。Nexuni 的軟體具備以下功能：即時監控和報告、月票管理、設備監控和維護、數據分析和預測，以及客製化服務。這些功能讓停車場管理更有效率，降低運營成本，提升用戶體驗。"
                  },
                  "en": {
                      "title": "Parking Management Control Center",
                      "subt1": "Applicable Areas",
                      "subl1": ["Parking Towers", "Underground Parking Lots", "Indoor Parking Lots", "Shopping Center Parking Lots", "Motorcycle Parking Lots"],
                      "subt2": "Technologies",
                      "subl2": ["Cloud Servers", "War Room Setup", "Remote Control"],
                      "subt3": "Current Issues",
                      "subc3": "Parking lot management struggles without backend software. Manual processes are inefficient and error-prone. On-site management is labor-intensive and costly. Maintenance is delayed, impacting user experience. Insufficient data analysis hampers decision-making. Poor customer experience results from manual payment systems. High operating costs and competition further challenge efficiency. Introducing Nexuni's backend software can address these issues, improving management and efficiency.",
                      "subt4": "Solution Description",
                      "subc4": "Nexuni's backend management software revolutionizes parking lot management. It automates tasks like monthly pass registration and equipment monitoring, improving efficiency and accuracy. Key functions include real-time monitoring, monthly pass management with online registration and payment reminders, equipment maintenance, and data analysis for informed decision-making. Customizable to each lot's needs, it ensures precise management tools tailored to specific requirements."
                  },
                  "ja": {
                      "title": "駐車管理コントロールセンター",
                      "subt1": "適用範囲",
                      "subl1": ["駐車タワー", "地下駐車場", "屋内駐車場", "ショッピングセンター駐車場", "オートバイ駐車場"],
                      "subt2": "使用技術",
                      "subl2": ["クラウドサーバー", "ウォールルーム構築", "リモートコントロール"],
                      "subt3": "現行の課題",
                      "subc3": "このようなバックエンド管理ソフトウェアがない場合、駐車場管理は複数の痛点に直面します。まず、手動管理は非効率的で、月次チケットの登録と管理はエラーが発生しやすく、効率が悪い。現場管理は労働コストと複雑さを増加させます。次に、機器のメンテナンスが適時に行われず、現場の機器は定期的な手動チェックが必要であり、故障の処理が遅れ、ユーザー体験に影響を与えます。第三に、データ管理と分析が不足しており、リアルタイムで駐車場の使用状況を把握するのが難しく、意思決定に支障をきたします。第四に、顧客体験が悪く、自動支払いと電子請求書サービスを提供できないため、サービス品質が不安定で、車主の満足度に影響を与えます。最後に、運営コストが高く、現場管理、機器のメンテナンス、およびデータ処理には大量の手作業が必要であり、競争力が低下します。",
                      "subt4": "ソリューション説明",
                      "subc4": "私たちが目にするほとんどの駐車場には現場スタッフがいませんが、実際にはバックエンドで多くの現場状況を追跡する必要があり、駐車場を効果的に管理する必要があります。月次チケットの登録、機器の設置と管理はほとんど手動で行われています。Nexuniは、これらの駐車場運営および管理の側面を支援するバックエンド管理ソフトウェアを提供し、駐車場の実際のニーズに基づいてカスタマイズされたソフトウェアを提供することで、管理をより効率的かつ正確にします。Nexuniのバックエンド管理ソフトウェアは、リアルタイムの監視と報告、月次チケット管理、機器の監視とメンテナンス、データ分析と予測、およびカスタマイズサービスなどの主要な機能を提供します。これらの機能により、駐車場管理がより効率的になり、運営コストが削減され、ユーザー体験が向上します。"
                  }
              }
          },
           {
              "zh": "路邊停車收費系統",
              "en": "Roadside Parking Meter System",
              "ja": "路上駐車料金システム",
              "group_tag": ["id1", "id2"],
              "img_url": "/assets/solution/A9.jpg",
              "detail_content": {
                  "zh": {
                      "title": "路邊停車收費系統",
                      "subt1": "適用場域",
                      "subl1": ["停車場繳費系統", "路邊停車格繳費系統"],
                      "subt2": "使用技術",
                      "subl2": ["雲端伺服器", "使用者介面", "手持式PDA系統", "商家支付串接"],
                      "subt3": "現有痛點",
                      "subc3": "目前的路邊停車收費系統面臨多重痛點：繳費方式不便，支付手段有限且操作繁瑣；監管和執法困難，逃費現象普遍且執法人員不足；數據管理和分析不足，無法即時掌握使用情況且數據利用率低；用戶體驗差，信息不透明且服務不完善；設備維護和管理成本高，設備故障頻繁且需要大量人力維護。這些問題導致運營效率低下、車主停車體驗差、管理成本增加和收費收入減少。",
                      "subt4": "方案說明",
                      "subc4": "引入多元化繳費系統，支援多達19種支付方式，提升支付便捷性，減少逃費狀況。智慧化管理系統，引進數據管理，即時了解路邊停車營運狀況。開單資料整合到大平台上，民眾可透過網頁查詢到停車費狀態，減少致電客服頻率，降低維護成本。"
                  },
                  "en": {
                      "title": "Roadside Parking Meter System",
                      "subt1": "Applicable Areas",
                      "subl1": ["Parking Lot Payment Systems", "Roadside parking meter systems"],
                      "subt2": "Technologies",
                      "subl2": ["Cloud Servers", "User Interface", "Handheld PDA Systems", "Merchant Payment Integration"],
                      "subt3": "Current Issues",
                      "subc3": "The current roadside parking fee system faces multiple challenges: inconvenient payment methods, supervision difficulties, inadequate data management, poor user experience, and high maintenance costs. These lead to low efficiency and revenue. Introducing intelligent and automated management systems can address these challenges by enhancing payment convenience, strengthening monitoring, improving data management, and reducing maintenance costs.",
                      "subt4": "Solution Description",
                      "subc4": "Introduce a diversified payment system, supporting up to 19 payment methods, to enhance payment convenience and reduce evasion. Implement an intelligent management system, introducing data management to understand the operational status of roadside parking in real-time. Integrate billing data onto a large platform, allowing the public to check parking fee statuses through a webpage, reducing the frequency of contacting customer service and lowering maintenance costs."
                  },
                  "ja": {
                      "title": "路上駐車料金システム",
                      "subt1": "適用範囲",
                      "subl1": ["駐車場料金システム", "路上駐車スペース料金システム"],
                      "subt2": "使用技術",
                      "subl2": ["クラウドサーバー", "ユーザーインターフェース", "ハンドヘルドPDAシステム", "商業支払い統合"],
                      "subt3": "現行の課題",
                      "subc3": "現在の路上駐車料金システムは複数の痛点に直面しています：支払い方法が不便で、支払い手段が限られ操作が煩雑です。監督と執行が困難で、料金逃れが広まり、執行員が不足しています。データ管理と分析が不足しており、リアルタイムで使用状況を把握できず、データ利用率が低いです。ユーザー体験が悪く、情報の透明性がなく、サービスが不完全です。機器の維持管理コストが高く、機器の故障が頻繁であり、多くの人手が必要です。これらの問題は運営効率の低下、ユーザーの駐車体験の悪化、管理コストの増加、収入の減少を引き起こします。",
                      "subt4": "ソリューション説明",
                      "subc4": "最大19種類の支払い方法をサポートする多様な支払いシステムを導入し、支払いの利便性を向上させ、料金逃れを減少させます。データ管理機能を備えたスマート管理システムを導入し、路上駐車の運営状況を即座に把握します。チケットデータを大規模プラットフォームに統合し、ユーザーはウェブで駐車料金の状況を確認できるようにし、カスタマーサービスへの電話の頻度を減らし、メンテナンスコストを削減します。"
                  }
              }
          },

                    {
    "zh": "智慧路邊停車收款摩托車",
    "en": "Automated Parking Enforcement System",
    "ja": "スマート路上駐車料金収集バイク",
    "group_tag": ["id1", "id2"],
    "img_url": "/assets/solution/A10.jpg",
    "detail_content": {
        "zh": {
            "title": "智慧路邊停車收款摩托車",
            "subt1": "適用場域",
            "subl1": ["路邊停車收款", "停車執法", "停車資訊搜集"],
            "subt2": "使用技術",
            "subl2": ["車牌辨識", "GPS定位", "影像定位", "RFID定位", "PDA系統串接"],
            "subt3": "現有痛點",
            "subc3": "目前，路邊停車收款摩托車面臨的主要痛點包括需要大量人力進行巡查和執法，成本高且效率低。收費員每半小時需繞一圈抄寫車牌和車格。此外，數據管理和分析不足，無法即時掌握停車情況，難以有效管理和調度。缺乏歷史數據分析，無法進行科學的停車需求預測和政策制定。",
            "subt4": "方案說明",
            "subc4": "此智慧路邊停車收費摩托車具備車牌辨識和車格辨識功能。這款電動摩托車採用超高頻 (UHF) 無線射頻識別 (RFID) 技術進行精準停車位辨識，內建的車牌辨識 (LPR) 功能自動辨識停放車輛的車牌。智慧停車摩托車能自動生成停車單據，並透過雲端後台串接，使用戶可在網站或超商繳費。此方案提高停車管理效率，減少人工干預，實現自動化管理，對城市停車管理具有實際應用價值。"
        },
        "en": {
            "title": "Automated Parking Enforcement System",
            "subt1": "Applicable Areas",
            "subl1": ["Roadside Parking Fee Collection", "Parking Enforcement", "Parking Information Collection"],
            "subt2": "Technologies",
            "subl2": ["License Plate Recognition", "GPS Positioning", "Image Positioning", "RFID Positioning", "PDA System Integration"],
            "subt3": "Current Issues",
            "subc3": "Roadside parking enforcement requires extensive manpower for on-site inspection and enforcement, leading to high costs and inefficiency. Attendees must patrol every half hour to record license plates and spaces. Moreover, inadequate data management impedes real-time understanding of motorcycle parking usage, hampering effective management and scheduling. The absence of historical data analysis hinders parking demand prediction and policy formulation.",
            "subt4": "Solution Description",
            "subc4": "We propose an automated parking enforcement system featuring license plate recognition and parking space identification. This electric motorcycle uses ultra-high frequency (UHF) RFID technology for precise parking space recognition. Its built-in license plate recognition (LPR) function automatically identifies parked vehicle plates and generates parking tickets. Integrated with a cloud backend, users can pay online or at convenience stores. This solution enhances parking management efficiency, reduces manual intervention, and automates urban parking management effectively."
        },
        "ja": {
            "title": "スマート路上駐車料金収集バイク",
            "subt1": "適用範囲",
            "subl1": ["路上駐車料金収集", "駐車執行", "駐車情報収集"],
            "subt2": "使用技術",
            "subl2": ["ナンバープレート認識", "GPSポジショニング", "画像ポジショニング", "RFIDポジショニング", "PDAシステム統合"],
            "subt3": "現行の課題",
            "subc3": "現在、路上駐車料金収集バイクは、現場での巡回や執行に多大な労力を要し、高コストで低効率という主要な痛点に直面しています。駐車料金の徴収員は、30分ごとに車両番号と駐車スペースを記録するために巡回する必要があります。また、データ管理と分析が不十分で、リアルタイムでオートバイの駐車状況を把握することが難しく、効果的な管理や調整が困難です。歴史的な駐車データの分析と利用が不足しており、科学的な駐車需要予測や政策立案が行えません。",
            "subt4": "ソリューション説明",
            "subc4": "私たちは、ナンバープレート認識と駐車スペース認識機能を備えたスマート路上駐車料金収集バイクのソリューションを提案します。この電動バイクは、超高周波（UHF）RFID技術を使用した正確な駐車スペース認識を実現するための位置決めアルゴリズムを採用しています。システム内蔵のナンバープレート認識（LPR）機能により、駐車された車両のナンバープレートを自動的に認識できます。スマート駐車バイクは、認識結果に基づいて自動的に駐車伝票を生成し、クラウドバックエンドに接続して、駐車ユーザーがオンラインやコンビニエンスストアで支払いを行えるようにします。このソリューションは、駐車管理の効率を向上させるだけでなく、手動介入を減らし、駐車管理の自動化を実現し、都市の駐車管理に実際の価値を提供します。"
        }
    }
}
]

        },
        {
          "title": {"zh": "AI智慧保全", "en": "AI Smart Security", "ja": "AIセキュリティ", "color": "#C581F0", "group_tag": ["id1", "id3"]},
          "content": [{
              "zh": "AI臉部辨識門禁管理",
              "en": "AI Facial Recognition Access Control",
              "ja": "AI顔認識アクセス制御",
              "group_tag": ["id1", "id3"],
              "img_url": "/assets/solution/B1.jpg",
              "detail_content": {
                  "zh": {
                      "title": "AI臉部辨識門禁管理",
                      "subt1": "適用場域",
                      "subl1": ["公司辦公大樓", "公共機構", "高級住宅社區", "教育機構", "醫療機構", "購物中心"],
                      "subt2": "使用技術",
                      "subl2": ["人臉辨識", "深度學習", "影像處理", "生物特徵偵測", "多重感測偵測技術", "網路安全"],
                      "subt3": "現有痛點",
                      "subc3": "現有的門禁管理系統依賴傳統刷卡或指紋識別方式，存在遺失卡片、指紋磨損等問題，識別效率和安全性較低。手動管理容易出現疏忽和失誤，影響整體安全性和管理效率。",
                      "subt4": "方案說明",
                      "subc4": "Nexuni的人臉辨識技術基於深度學習，通過設置攝像頭捕捉和識別進出人員的臉部，快速確認和管理身份。系統支持多種進出模式，如限時模式和通行模式，靈活應對不同場景。Nexuni的人臉辨識技術自動化和智能化管理進出人流和門禁識別，提升管理效率和準確性，減少管理人員的工作量和失誤。"
                  },
                  "en": {
                      "title": "AI Facial Recognition Access Control",
                      "subt1": "Applicable Areas",
                      "subl1": ["Office Buildings", "Public Institutions", "High-end Residential Communities", "Educational Institutions", "Medical Institutions", "Shopping Centers"],
                      "subt2": "Technologies",
                      "subl2": ["Facial Recognition", "Deep Learning", "Image Processing", "Biometric Detection", "Multimodal Detection", "Network Security"],
                      "subt3": "Current Issues",
                      "subc3": "Existing access control management systems rely on traditional methods such as card swiping or fingerprint recognition, which present issues like lost cards or worn-out fingerprints, resulting in lower identification efficiency and security. Manual management is prone to negligence and errors, impacting overall security and management efficiency.",
                      "subt4": "Solution Description",
                      "subc4": "Nexuni's facial recognition technology, developed with deep learning techniques, swiftly captures and identifies individuals via installed cameras. It compares recognition results for quick identity confirmation and management. Supporting timed access and passage mode, it offers flexible adjustments for various scenarios. Managing flow and access control, it automates systems, enhancing efficiency, accuracy, and reducing workload and errors among personnel."
                    },
                  "ja": {
                      "title": "AI顔認識アクセス制御",
                      "subt1": "適用範囲",
                      "subl1": ["オフィスビル", "公共機関", "高級住宅コミュニティ", "教育機関", "医療機関", "ショッピングセンター"],
                      "subt2": "使用技術",
                      "subl2": ["顔認識", "ディープラーニング", "画像処理", "生体認識", "マルチモーダル認識技術", "ネットワークセキュリティ"],
                      "subt3": "現行の課題",
                      "subc3": "既存のアクセス制御システムは、従来のカードスワイプや指紋認識方式に依存しており、カードの紛失や指紋の摩耗などの問題があり、認識効率とセキュリティが低下します。手動管理は見落としやミスが発生しやすく、全体のセキュリティと管理効率に影響を与えます。",
                      "subt4": "ソリューション説明",
                      "subc4": "Nexuniの顔認識技術は主にディープラーニングに基づいて開発され、カメラを設置して出入りする人の顔をキャプチャして認識し、識別結果を照合して出入りする人の身元を迅速に確認および管理します。同時に、システムは限時モードや通行モードなどの複数の出入りモードをサポートし、さまざまなアプリケーションシナリオに応じて柔軟に調整できます。Nexuniの顔認識技術を通じて人の流れとアクセス識別を管理し、アクセス制御システムの自動化とインテリジェンスを実現し、管理効率と正確性を向上させ、アクセス制御担当者の作業負担とエラーの機会を減らします。"
                  }
              }
          },

                    {
    "zh": "科技違停執法",
    "en": "Illegal Parking Enforcement",
    "ja": "違法駐車取り締まり",
    "group_tag": ["id1", "id3"],
    "img_url": "/assets/solution/B2.jpg",
    "detail_content": {
        "zh": {
            "title": "科技違停執法",
            "subt1": "適用場域",
            "subl1": ["校園周邊", "醫院周邊", "商業區", "都市街道", "卸貨區"],
            "subt2": "使用技術",
            "subl2": ["影像處理", "深度學習", "物件檢測", "特徵抽取", "追蹤演算"],
            "subt3": "現有痛點",
            "subc3": "傳統的違停執法方式主要依賴人工至現場巡查，效率低下且容易出現遺漏和誤判。違停問題嚴重影響城市交通秩序，尤其是在繁忙時段和重要地段。人力成本高，執法人員在處理違停問題上耗費大量時間和精力。手動記錄和處理違停信息，容易出現數據錯誤和管理困難。",
            "subt4": "方案說明",
            "subc4": "Nexuni的科技違停執法系統利用影像辨識技術、深度學習算法和實時追蹤技術，通過部署在街道和停車場的網路攝像頭，實時捕捉和識別違規停車行為。系統自動記錄車牌號碼、時間和地點，並將數據傳送至中央管理平台進行分析處理。利用邊緣計算技術，本地快速處理影像數據，減少延遲，提高識別準確性。自動化特性大大減少對人工巡查的依賴，提高執法效率，降低人力成本。同時，通過大數據分析，管理部門可以根據歷史數據制定更有效的違停管理策略，優化城市交通秩序。"
        },
        "en": {
            "title": "Illegal Parking Enforcement",
            "subt1": "Applicable Areas",
            "subl1": ["School Campus", "Hospitals", "Commercial Areas", "Urban Streets", "Loading Zones"],
            "subt2": "Technologies",
            "subl2": ["Image Processing", "Deep Learning", "Object Detection", "Feature Extraction", "Tracking Algorithms"],
            "subt3": "Current Issues",
            "subc3": "The challenges with illegal parking enforcement arise from heavy reliance on manual patrols, leading to inefficiencies, oversights, and traffic disruptions. High labor costs exacerbate the problem, with officers spending considerable time and effort on violations. Manual data recording also introduces errors and management complexities. Effective solutions are crucial to enhance efficiency and traffic management.",
            "subt4": "Solution Description",
            "subc4": "Our solution utilizes advanced image processing and machine learning to monitor and detect parking violations in urban, commercial, hospital, school, and industrial areas in real-time. By automatically identifying illegal parking and issuing warnings or citations, it reduces the need for manual patrols, enhances enforcement efficiency, and improves traffic flow and safety. Data analysis enables optimization of enforcement strategies and resource allocation, resulting in more effective management of parking violations and improved urban mobility."
        },
        "ja": {
            "title": "違法駐車取り締まり",
            "subt1": "適用範囲",
            "subl1": ["キャンパス周辺", "病院周辺", "商業地区", "都市の道路", "荷物降ろし場"],
            "subt2": "使用技術",
            "subl2": ["画像処理", "ディープラーニング", "オブジェクト検出", "特徴抽出", "追跡アルゴリズム"],
            "subt3": "現行の課題",
            "subc3": "従来の違法駐車取り締まり方法は、主に手動による現場巡回に依存しており、効率が低く、見落としや誤判断が発生しやすいです。違法駐車は、特に繁忙時間帯や重要な場所で、都市の交通秩序に深刻な影響を与えます。労働コストが高く、取り締まりスタッフは違法駐車問題に多くの時間と労力を費やします。違法駐車情報の手動記録と処理は、データエラーや管理の困難を招きやすいです。",
            "subt4": "ソリューション説明",
            "subc4": "Nexuniの違法駐車取り締まりシステムは、先進的な画像認識技術、ディープラーニングアルゴリズム、およびリアルタイム追跡技術を活用しています。街道や駐車場に設置されたネットワークカメラを通じて、システムは違法駐車行動をリアルタイムで捕捉および識別します。システムは、違法に駐車された車両のナンバープレート番号、時間、および場所を自動的に記録し、データを中央管理プラットフォームに送信して分析および処理します。エッジコンピューティング技術を利用して、システムはローカルで迅速に画像データを処理し、遅延を減らし、認識精度を向上させます。システムの自動化特性は、手動巡回への依存を大幅に減少させ、取り締まり効率を向上させ、労働コストを削減します。また、ビッグデータ分析を通じて、管理部門は履歴データに基づいて、より効果的な違法駐車管理戦略を策定し、都市交通秩序をさらに最適化することができます。"
        }
    }
},

                    {
    "zh": "影像卸貨區監測",
    "en": "Image-based Loading Zone Monitoring",
    "ja": "画像ベースの荷降ろしエリア監視",
    "group_tag": ["id1", "id3"],
    "img_url": "/assets/solution/B3.jpg",
    "detail_content": {
        "zh": {
            "title": "影像卸貨區監測",
            "subt1": "適用場域",
            "subl1": ["公司工廠", "限制暫停區域", "大型超市", "物流中心或倉儲設施"],
            "subt2": "使用技術",
            "subl2": ["深度學習", "物件檢測", "特徵抽取", "姿態檢測"],
            "subt3": "現有痛點",
            "subc3": "傳統的卸貨區管理主要依賴人工監控，容易出現監管疏漏。人工監控效率低下，無法實時追蹤卸貨區的動態情況。長時間確認是否違停或是確實有在卸貨需要耗費人力。",
            "subt4": "方案說明",
            "subc4": "Nexuni的影像卸貨區監測系統利用影像處理和深度學習技術，實現對卸貨區域的全方位實時監控。通過部署網路攝像頭，系統自動識別和追蹤車輛和人員，及時檢測異常，如未經授權的人員進入、貨物移動或長時間占用無卸貨工作的車輛。邊緣計算技術使系統能本地快速處理影像數據，實現即時反應。物聯網技術集成使監測數據實時傳送至中央管理平台，供管理人員查看和分析。通過數據分析，系統生成詳細報告，幫助管理人員優化卸貨流程，提高工作效率。"
        },
        "en": {
            "title": "Image-based Loading Zone Monitoring",
            "subt1": "Applicable Areas",
            "subl1": ["Company Factories", "Restricted Stopping Areas", "Large Supermarkets", "Logistics Centers or Warehousing Facilities"],
            "subt2": "Technologies",
            "subl2": ["Deep Learning", "Object Detection", "Feature Extraction", "Pose Detection"],
            "subt3": "Current Issues",
            "subc3": "Traditional management of loading zones relies heavily on manual monitoring, leading to oversight and inefficiencies. Manual surveillance lacks real-time tracking of loading zone activity, resulting in delays and difficulty in confirming legitimate unloading activities. This prolonged confirmation process consumes manpower and hampers overall efficiency.",
            "subt4": "Solution Description",
            "subc4": "Nexuni's image-based unloading zone monitoring system employs advanced image processing and deep learning for real-time monitoring. Using network cameras, it automatically identifies vehicles and personnel, detecting unauthorized entry, movement of goods, and prolonged vehicle occupancy. Edge computing processes data swiftly locally for immediate responses, while IoT integration transmits monitoring data to the central platform for analysis. Detailed reports aid management in optimizing unloading processes and enhancing efficiency."
        },
        "ja": {
            "title": "画像ベースの荷降ろしエリア監視",
            "subt1": "適用範囲",
            "subl1": ["会社の工場", "制限停止エリア", "大型スーパーマーケット", "物流センターまたは倉庫施設"],
            "subt2": "使用技術",
            "subl2": ["ディープラーニング", "オブジェクト検出", "特徴抽出", "姿勢検出"],
            "subt3": "現行の課題",
            "subc3": "従来の荷降ろしエリア管理は主に手動監視に依存しており、監督の見落としが発生しやすいです。手動監視は効率が低く、荷降ろしエリアの動的状況をリアルタイムで追跡することはできません。長時間にわたって違法駐車か実際に荷降ろしを行っているかを確認するには人手が必要です。",
            "subt4": "ソリューション説明",
            "subc4": "Nexuniの画像ベースの荷降ろしエリア監視システムは、先進的な画像処理とディープラーニング技術を利用して、荷降ろしエリアの全方位リアルタイム監視を実現します。ネットワークカメラを配置することで、システムは荷降ろしエリアの車両と人員を自動的に識別および追跡し、未許可の人物の侵入や貨物の移動、長時間占有しているが荷降ろし作業を行っていない車両などの異常事態を即座に検出します。エッジコンピューティング技術の適用により、システムはローカルで迅速に画像データを処理し、即時反応を実現します。また、IoT技術の統合により、荷降ろしエリアの監視データをリアルタイムで中央管理プラットフォームに送信し、管理者が閲覧および分析できるようにします。データ分析を通じて、システムは詳細な報告を生成し、管理者が荷降ろしプロセスを最適化し、作業効率を向上させるのに役立ちます。"
        }
    }
},

                    {
    "zh": "電子圍籬",
    "en": "Digital Fence",
    "ja": "電子フェンス",
    "group_tag": ["id1", "id3"],
    "img_url": "/assets/solution/B4.jpg",
    "detail_content": {
        "zh": {
            "title": "電子圍籬",
            "subt1": "適用場域",
            "subl1": ["工廠", "學校", "醫院", "動物園", "住宅社區"],
            "subt2": "使用技術",
            "subl2": ["實時多串流處理", "深度學習", "影像識別", "人員偵測", "物體追蹤"],
            "subt3": "現有痛點",
            "subc3": "傳統的保安監控方法需要大量的人力、物力和時間成本，效率低下且易受環境干擾，容易出現漏洞。",
            "subt4": "方案說明",
            "subc4": "Nexuni的虛擬巡邏和數位圍籬則利用AI影像分析技術，透過智慧化的監控解決方案，解決了這些問題。虛擬巡邏和數位圍籬利用機器學習和影像分析技術，分析特定監視器片段的影像信息。當監測區域內出現任何動靜時，系統可以立即發出警報，通知保安人員，讓他們可以快速反應並處理，大大增強了場所的安全性。"
        },
        "en": {
            "title": "Digital Fence",
            "subt1": "Applicable Areas",
            "subl1": ["Factories", "Schools", "Hospitals", "Zoos", "Residential Communities"],
            "subt2": "Technologies",
            "subl2": ["Real-time Multistream Processing", "Deep Learning", "Image Recognition", "Personnel Detection", "Object Tracking"],
            "subt3": "Current Issues",
            "subc3": "Traditional security monitoring methods require significant manpower, material, and time costs, are inefficient, and are easily affected by environmental factors, leading to vulnerabilities.",
            "subt4": "Solution Description",
            "subc4": "Nexuni's virtual patrols and digital perimeters employ AI image analysis for intelligent monitoring. Utilizing machine learning, they analyze surveillance camera segments for any movement or activity. Upon detection, alerts are triggered, notifying security personnel for swift response, thus enhancing premises security significantly."
        },
        "ja": {
            "title": "電子フェンス",
            "subt1": "適用範囲",
            "subl1": ["工場", "学校", "病院", "動物園", "住宅コミュニティ"],
            "subt2": "使用技術",
            "subl2": ["リアルタイムマルチストリーム処理", "ディープラーニング", "画像認識", "人物検出", "オブジェクト追跡"],
            "subt3": "現行の課題",
            "subc3": "従来のセキュリティ監視方法は、多くの人員、資材、時間を要し、効率が悪く、環境要因の影響を受けやすいため、脆弱性が生じやすいです。",
            "subt4": "ソリューション説明",
            "subc4": "Nexuniの仮想パトロールとデジタルフェンスは、AI画像解析技術を利用して、インテリジェントな監視ソリューションを通じてこれらの問題に対処します。仮想パトロールとデジタルフェンスは、機械学習と画像解析技術を使用して、特定の監視セグメントからの画像情報を分析します。監視エリア内で何らかの動きが発生すると、システムは即座に警報を発し、セキュリティ担当者に通知し、迅速に対応して状況を処理できるようにし、場所の安全性を大幅に向上させます。"
        }
    }
},

                    {
        "zh": "虛擬巡邏",
        "en": "Virtual Patrol",
        "ja": "バーチャルパトロール",
        "group_tag": ["id1", "id3"],
        "img_url": "/assets/solution/B5.jpg",
        "detail_content": {
            "zh": {
                "title": "虛擬巡邏",
                "subt1": "適用場域",
                "subl1": ["公司辦公大樓", "工廠", "校園", "住宅社區", "商業中心", "公家機關"],
                "subt2": "使用技術",
                "subl2": ["實時多串流處理", "人工智慧輔助分析", "中央控制系統", "網路安全"],
                "subt3": "現有痛點",
                "subc3": "傳統人工巡邏成本高且效率低。安保人員容易漏巡或遲到，影響安全。手動巡邏記錄不易保真。",
                "subt4": "方案說明",
                "subc4": "Nexuni的虛擬巡邏系統通過多個高清攝像頭和中央控制系統，實現如同現場巡邏的效果，並利用AI技術自動檢測異常行為，發出警報，生成巡邏記錄，確保安全管理。"
            },
            "en": {
                "title": "Virtual Patrol",
                "subt1": "Applicable Areas",
                "subl1": ["Corporate Office Buildings", "Factories", "Campuses", "Residential Communities", "Commercial Centers", "Government Agencies"],
                "subt2": "Technologies",
                "subl2": ["Real-time Multi-stream Processing", "AI-assisted Analysis", "Central Control System", "Cybersecurity"],
                "subt3": "Current Issues",
                "subc3": "Traditional patrols are labor-intensive and costly, with low efficiency. Security personnel may miss patrols or be late, impacting safety. Manual patrol records are prone to errors.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's virtual patrol system uses high-definition cameras to stream real-time footage to the central control system. Security personnel can monitor critical areas remotely, mimicking on-site patrols. The system ensures timely virtual patrols through AI analysis, detecting abnormal behavior and events, and alerting personnel promptly. It also generates patrol records to ensure timely and effective patrols."
            },
            "ja": {
                "title": "バーチャルパトロール",
                "subt1": "適用分野",
                "subl1": ["企業オフィスビル", "工場", "キャンパス", "住宅コミュニティ", "商業センター", "政府機関"],
                "subt2": "使用技術",
                "subl2": ["リアルタイムマルチストリーム処理", "AI支援分析", "中央制御システム", "サイバーセキュリティ"],
                "subt3": "現行の課題",
                "subc3": "従来のパトロールは労働集約的でコストが高く、効率が低い。警備員が巡回を見逃したり遅刻したりすると、安全に影響が出る。手動巡回記録はエラーが発生しやすい。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniのバーチャルパトロールシステムは、複数のHDカメラと中央制御システムを使用してリアルタイムの監視を実現します。AI技術により異常行動を検出し、警備員にアラートを発し、パトロール記録を自動生成して効果的な安全管理を確保します。"
            }
        }
    },
    {
        "zh": "智慧安保中控中心",
        "en": "Intelligent Security Control Center",
        "ja": "スマートセキュリティコントロールセンター",
        "group_tag": ["id1", "id3"],
        "img_url": "/assets/solution/B6.jpg",
        "detail_content": {
            "zh": {
                "title": "智慧安保中控中心",
                "subt1": "適用場域",
                "subl1": ["公司辦公大樓", "工廠", "校園", "住宅社區", "商業中心", "公家機關"],
                "subt2": "使用技術",
                "subl2": ["實時多串流處理", "影像辨識", "深度學習", "物聯網(IoT)", "大數據分析", "即時通訊技術"],
                "subt3": "現有痛點",
                "subc3": "傳統安保系統依賴人工監控，容易出現疏忽與失誤，影響整體安全性。多數安保系統獨立運作，無法整合各系統數據，無法提供全方位的安全管理。",
                "subt4": "方案說明",
                "subc4": "Nexuni的智慧安保控制中心整合了先進的影像辨識、深度學習和人工智慧技術，透過物聯網技術連結各種感測器和監控設備，實現全方位的即時監控與安全管理。控制中心能夠即時分析來自各設備的數據，進行異常行為偵測和預警，並自動啟動應對措施，確保各場域的安全。"
            },
            "en": {
                "title": "Intelligent Security Control Center",
                "subt1": "Applicable Areas",
                "subl1": ["Corporate Office Buildings", "Factories", "Campuses", "Residential Communities", "Commercial Centers", "Government Agencies"],
                "subt2": "Technologies",
                "subl2": ["Real-time Multi-stream Processing", "Image Recognition", "Deep Learning", "Internet of Things (IoT)", "Big Data Analysis", "Instant Communication Technology"],
                "subt3": "Current Issues",
                "subc3": "Traditional security systems rely on manual monitoring, prone to errors, and lack integration. They fail to provide comprehensive management and real-time alerts, leading to inefficiency and high costs in effectively managing large areas.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's Intelligent Security Control Center integrates image recognition, deep learning, and AI, connecting sensors and devices via IoT for real-time monitoring and comprehensive security management. It analyzes data instantly, detects anomalies, and issues alerts, triggering automated responses. It also enables instant communication during emergencies, providing on-site images and data for quick decision-making. Additionally, it records and analyzes historical data, offering detailed reports to optimize security strategies and management efficiency."
            },
            "ja": {
                "title": "スマートセキュリティコントロールセンター",
                "subt1": "適用分野",
                "subl1": ["企業オフィスビル", "工場", "キャンパス", "住宅コミュニティ", "商業センター", "政府機関"],
                "subt2": "使用技術",
                "subl2": ["リアルタイムマルチストリーム処理", "画像認識", "深層学習", "モノのインターネット (IoT)", "ビッグデータ分析", "即時通信技術"],
                "subt3": "現行の課題",
                "subc3": "従来のセキュリティシステムは手動監視に依存しており、見落としやエラーが発生しやすく、全体的なセキュリティに影響を与える。ほとんどのセキュリティシステムは独立して動作し、データを統合して包括的なセキュリティ管理を提供することができない。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniのスマートセキュリティコントロールセンターは、高度な画像認識、深層学習、AI技術を統合し、IoTを通じてさまざまなセンサーや監視デバイスを接続します。これにより、包括的なリアルタイム監視とセキュリティ管理を実現します。コントロールセンターは、すべてのデバイスからのデータを即座に分析し、異常行動を検出して警告し、自動的に対応措置を開始して安全を確保します。"
            }
        }
    },
    {
        "zh": "智慧保全機器人",
        "en": "Smart Security Robot",
        "ja": "スマートセキュリティロボット",
        "group_tag": ["id1", "id3"],
        "img_url": "/assets/solution/B7.jpg",
        "detail_content": {
            "zh": {
                "title": "智慧保全機器人",
                "subt1": "適用場域",
                "subl1": ["工廠", "商場", "學校", "機場", "公園"],
                "subt2": "使用技術",
                "subl2": ["人工智慧（AI）", "自主移動機器人（AMR）平台", "影像辨識", "感測器融合技術", "遠程控制"],
                "subt3": "現有痛點",
                "subc3": "目前安全保障工作需要大量人力資源，操作效率低且成本高。傳統監控系統存在監控盲區和延遲反應的問題。",
                "subt4": "方案說明",
                "subc4": "Nexuni提出的智慧保全機器人解決方案旨在減少人力需求並提升操作效率。該方案包括一個自主移動機器人（AMR）平台，利用AI和算法實現感測和決策能力。智慧保全機器人在辦公室、工廠、商場、醫院、酒店和機場等場域中自主導航，完成引導訪客、運送文件和物料、巡邏等任務。緊急情況下，機器人可由人員接管控制，並提供即時影像增強監控效果。現場硬體設施幫助機器人導航和充電。此解決方案實現自動化安全保障，提高運營效率並降低成本。"
            },
            "en": {
                "title": "Smart Security Robot",
                "subt1": "Applicable Areas",
                "subl1": ["Factories", "Shopping Malls", "Schools", "Airports", "Parks"],
                "subt2": "Technologies",
                "subl2": ["Artificial Intelligence (AI)", "Autonomous Mobile Robot (AMR) Platform", "Image Recognition", "Sensor Fusion Technology", "Remote Control"],
                "subt3": "Current Issues",
                "subc3": "Current security measures require a large amount of manpower, leading to low operational efficiency and high costs. Traditional surveillance systems suffer from blind spots and delayed responses. Large public places such as airports and hospitals require more patrols and security measures, but manual patrol methods are ineffective in achieving efficient and comprehensive monitoring.",
                "subt4": "Solution Description",
                "subc4": "Nexuni introduces a Smart Security Robot solution to streamline operations and minimize manpower. The solution features an Autonomous Mobile Robot (AMR) equipped with AI and algorithms for sensing and decision-making. These Smart Security Robots autonomously navigate various environments like offices, factories, and malls, performing tasks like guiding visitors and conducting patrols. In emergencies, personnel can control the robot manually, enhancing monitoring with real-time images. On-site hardware facilitates navigation and charging. Nexuni's solution automates security, boosts efficiency, and cuts costs."
            },
            "ja": {
                "title": "スマートセキュリティロボット",
                "subt1": "適用分野",
                "subl1": ["工場", "ショッピングモール", "学校", "空港", "公園"],
                "subt2": "使用技術",
                "subl2": ["人工知能（AI）", "自律移動ロボット（AMR）プラットフォーム", "画像認識", "センサー融合技術", "遠隔制御"],
                "subt3": "現行の課題",
                "subc3": "現在のセキュリティ作業は多くの人手を必要とし、効率が低く、コストが高い。従来の監視システムには監視の死角があり、反応が遅れることがある。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniのスマートセキュリティロボットソリューションは、人手の必要性を減らし、操作効率を向上させることを目指しています。このソリューションには、AIとアルゴリズムを使用して感知と意思決定を行う自律移動ロボット（AMR）プラットフォームが含まれています。スマートセキュリティロボットは、オフィス、工場、ショッピングモール、病院、ホテル、空港などで、訪問者の案内、書類や物品の輸送、巡回などのさまざまなタスクを自律的に完了することができます。緊急時には、担当者が制御を引き継ぎ、監視を強化するためにリアルタイムの画像を提供します。現場のハードウェアはナビゲーションと充電を支援します。Nexuniのソリューションは、セキュリティを自動化し、効率を向上させ、コストを削減します。"
            }
        }
    }]
      },
      {
        "title": {"zh": "AI設施管理", "en": "AI Facility Management", "ja": "AI施設管理", "color": "#F08600", "group_tag": ["id1", "id4"]},
        "content": [{
        "zh": "智慧廁所管理系統",
        "en": "Smart Toilet Management System",
        "ja": "スマートトイレ管理システム",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C1.jpg",
        "detail_content": {
            "zh": {
                "title": "智慧廁所管理系統",
                "subt1": "適用場域",
                "subl1": ["商場", "機場", "車站", "劇院", "辦公大樓", "醫院"],
                "subt2": "使用技術",
                "subl2": ["多項感測器", "物聯網（IoT）", "使用者回饋面板", "人流檢測", "資料分析"],
                "subt3": "現有痛點",
                "subc3": "傳統廁所管理依賴人工巡檢，容易出現耗材不足、衛生環境差等問題。使用者無法即時反映廁所使用情況，管理者無法即時獲取反饋並進行改善。缺乏即時數據支持，管理者無法高效地進行資源調配和維護。",
                "subt4": "方案說明",
                "subc4": "Nexuni的智慧廁所管理系統結合多種感測技術，提供全面的廁所使用監控與管理解決方案。系統透過氨氣感測器監測空氣質量，當異味超標時自動通知清潔人員進行清潔。洗手液和廁紙感測器即時監測耗材剩餘量，避免不足。使用者回饋面板讓使用者即時反映使用情況和建議，管理者可迅速改善服務。門口攝影機負責人流檢測，預測高峰時段並進行調度。物聯網技術將所有感測器數據即時傳送至中央管理平台，提供管理者即時數據支援和報告。"
            },
            "en": {
                "title": "Smart Toilet Management System",
                "subt1": "Applicable Areas",
                "subl1": ["Shopping Malls", "Airports", "Stations", "Theaters", "Office Buildings", "Hospitals"],
                "subt2": "Technologies",
                "subl2": ["Multiple Sensors", "Internet of Things (IoT)", "User Feedback Panel", "Crowd Detection", "Data Analysis"],
                "subt3": "Current Issues",
                "subc3": "Traditional toilet management relies on manual inspection, leading to issues like insufficient supplies and hygiene concerns. This manual approach incurs high labor costs, especially in large buildings. Users can't provide real-time feedback, and managers struggle to promptly gather data for improvements. Predicting toilet usage is challenging, resulting in queues during peak hours and inadequate management. Real-time data support is lacking, hindering resource allocation and maintenance efficiency.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's Smart Toilet Management System revolutionizes restroom management with advanced sensing technologies. An ammonia sensor monitors air quality, alerting staff when odors exceed acceptable levels. Real-time sensors for liquid soap and toilet paper prevent shortages. User feedback panels provide instant input for service enhancements. Entrance cameras track people flow, offering usage statistics and peak period predictions. IoT integration feeds all sensor data into a central platform for real-time insights and reports. This system enhances restroom management efficiency and user satisfaction, ensuring optimal conditions at all times."
            },
            "ja": {
                "title": "スマートトイレ管理システム",
                "subt1": "適用分野",
                "subl1": ["ショッピングモール", "空港", "駅", "劇場", "オフィスビル", "病院"],
                "subt2": "使用技術",
                "subl2": ["複数のセンサー", "モノのインターネット（IoT）", "ユーザーフィードバックパネル", "人流検出", "データ分析"],
                "subt3": "現行の課題",
                "subc3": "従来のトイレ管理は手動検査に依存しており、消耗品の不足や衛生環境の悪化などの問題が発生しやすい。利用者はトイレの使用状況を即座に報告できず、管理者はリアルタイムのフィードバックを受け取れない。リアルタイムデータがないため、管理者は効率的にリソースの割り当てやメンテナンスができない。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniのスマートトイレ管理システムは、さまざまなセンサー技術を組み合わせて、包括的なトイレの監視と管理を提供します。アンモニアセンサーが空気の質を監視し、異臭が基準を超えた場合は自動的に清掃員に通知します。洗浄液やトイレットペーパーのセンサーは消耗品の残量をリアルタイムで監視し、不足を防ぎます。ユーザーフィードバックパネルは、利用者がトイレの状況や提案を即座に報告でき、管理者はフィードバックに基づいてサービスを迅速に改善できます。入口のカメラは人流を検出し、ピーク時を予測して調整します。IoT技術により、すべてのセンサーデータはリアルタイムで中央管理プラットフォームに送信され、管理者に即時のデータサポートとレポートを提供します。"
            }
        }
    },
    {
        "zh": "人員物體虛擬定位",
        "en": "Virtual Positioning of Personnel and Objects",
        "ja": "人物・物体のバーチャルポジショニング",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C2.jpg",
        "detail_content": {
            "zh": {
                "title": "人員物體虛擬定位",
                "subt1": "適用場域",
                "subl1": ["籃球訓練場", "籃球比賽場地", "其他球類項目"],
                "subt2": "使用技術",
                "subl2": ["深度學習", "影像處理", "人員檢測", "姿態檢測", "數據分析"],
                "subt3": "現有痛點",
                "subc3": "傳統的籃球訓練和比賽分析主要依賴教練的經驗和視覺觀察，可能存在主觀偏差，難以獲取精確的運動數據。缺乏對戰術執行的全面和系統性分析，難以精準評估球員的表現和戰術配合度。",
                "subt4": "方案說明",
                "subc4": "Nexuni的人員物體虛擬定位系統利用先進的人員和姿態檢測技術，實時捕捉籃球場上球員的位置和動作。系統透過多攝影機同步錄製比賽或訓練，利用深度學習和影像處理技術準確分析每位球員的位置和姿勢。大數據分析評估戰術執行完整度，確定球員角色和貢獻。系統量化球員動作標準，提供詳細姿勢評估報告，幫助教練精確指導球員改善技術。"
            },
            "en": {
                "title": "Virtual Positioning of Personnel and Objects",
                "subt1": "Applicable Areas",
                "subl1": ["Basketball Training Courts", "Basketball Game Venues", "Other Sports Arenas"],
                "subt2": "Technologies",
                "subl2": ["Deep Learning", "Image Processing", "Personnel Detection", "Pose Detection", "Data Analysis"],
                "subt3": "Current Issues",
                "subc3": "Traditional basketball training and game analysis heavily rely on coach experience and visual observation, leading to subjective biases and imprecise data collection. Players struggle to assess their own training due to this reliance. There's a lack of systematic tactical analysis, hindering precise evaluation of player performance and coordination. Quantifying player posture and movement standards is difficult, impacting technical improvement. Manual data recording is inefficient and error-prone, lacking real-time training suggestions.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's personnel and object virtual positioning system uses advanced technology to capture basketball players' movements in real-time. Multiple cameras record matches or training sessions, with deep learning and image processing analyzing player positions and posture changes accurately. Big data analysis assesses tactical execution, determines roles, and evaluates contributions. The system quantifies movement standards and provides detailed posture assessment reports for precise guidance. It generates individual and team performance reports, aiding in targeted training plans to improve tactical execution and individual performance."
            },
            "ja": {
                "title": "人物・物体のバーチャルポジショニング",
                "subt1": "適用分野",
                "subl1": ["バスケットボール練習場", "バスケットボール試合会場", "その他のスポーツ"],
                "subt2": "使用技術",
                "subl2": ["深層学習", "画像処理", "人物検出", "ポーズ検出", "データ分析"],
                "subt3": "現行の課題",
                "subc3": "従来のバスケットボールの練習および試合の分析は、コーチの経験や視覚的観察に大きく依存しており、主観的な偏りが生じる可能性があり、正確な動作データを取得することが困難です。戦術の実行に関する包括的かつ体系的な分析が不足しており、選手のパフォーマンスや戦術の連携度を正確に評価することが難しいです。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniの人物・物体のバーチャルポジショニングシステムは、高度な人物検出およびポーズ検出技術を利用して、バスケットボール選手の位置と動作をリアルタイムでキャプチャします。システムは複数のカメラを使用して試合や練習セッションを記録し、深層学習と画像処理技術を使用して各選手の動きや姿勢の変化を正確に分析します。ビッグデータ分析を通じて、システムは戦術の実行の完全性を包括的に評価し、各選手の戦術における役割と貢献度を特定し、技術動作の改善をコーチが正確に指導できるように詳細な姿勢評価レポートを提供します。"
            }
        }
    },
    {
        "zh": "智慧點餐系統",
        "en": "Smart Ordering System",
        "ja": "スマートオーダーシステム",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C3.jpg",
        "detail_content": {
            "zh": {
                "title": "智慧點餐系統",
                "subt1": "適用場域",
                "subl1": ["餐廳", "咖啡廳", "速食店", "酒吧", "自助餐廳", "餐飲外送平台"],
                "subt2": "使用技術",
                "subl2": ["大數據分析", "GUI使用介面"],
                "subt3": "現有痛點",
                "subc3": "訂單處理效率低、人工成本高、顧客等待時間長及菜品推薦不準確等問題。顧客服務體驗差，從而影響顧客的滿意度和回頭率。",
                "subt4": "方案說明",
                "subc4": "Nexuni的智慧點餐系統包括點餐機和線上點餐平台，讓顧客可以通過系統快速下單。後端使用大數據分析，精準推薦菜品並優化菜單排列。該系統能顯著降低人工成本，提升訂單處理效率，增強顧客服務體驗，從而提高餐廳的運營效益和競爭力。"
            },
            "en": {
                "title": "Smart Ordering System",
                "subt1": "Applicable Areas",
                "subl1": ["Restaurants", "Cafes", "Fast Food Joints", "Bars", "Buffets", "Food Delivery Platforms"],
                "subt2": "Technologies",
                "subl2": ["Big Data Analysis", "GUI Interface"],
                "subt3": "Current Issues",
                "subc3": "Issues such as low order processing efficiency, high labor costs, long customer wait times, and inaccurate dish recommendations persist. Poor customer service experience affecting customer satisfaction and retention. High error rates in traditional ordering methods and difficulty in reconciling payments.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's Smart Ordering System comprises both in-store kiosks and an online ordering platform, enabling customers to place orders swiftly through the system. Leveraging big data analysis on the backend, the system accurately recommends dishes and optimizes menu layouts. This system significantly reduces labor costs, enhances order processing efficiency, improves customer service experience, thus boosting the operational efficiency and competitiveness of restaurants."
            },
            "ja": {
                "title": "スマートオーダーシステム",
                "subt1": "適用分野",
                "subl1": ["レストラン", "カフェ", "ファストフード店", "バー", "ビュッフェ", "フードデリバリープラットフォーム"],
                "subt2": "使用技術",
                "subl2": ["ビッグデータ分析", "GUIインターフェース"],
                "subt3": "現行の課題",
                "subc3": "注文処理効率が低く、人件費が高く、顧客の待ち時間が長く、料理の推奨が不正確です。顧客サービスの体験が悪く、顧客満足度とリピート率に影響します。",
                "subt4": "解決策の説明",
                "subc4": "Nexuniのスマートオーダーシステムには、注文機とオンライン注文プラットフォームが含まれており、顧客がシステムを通じて迅速に注文を行うことができます。バックエンドはビッグデータ分析を使用して、料理を正確に推奨し、メニューの配置を最適化します。このシステムは、労働コストを大幅に削減し、注文処理効率を向上させ、顧客サービスの体験を強化し、レストランの運営効率と競争力を高めます。"
            }
        }
    },
    {
        "zh": "AI智慧客服",
        "en": "Artificial Intelligence Customer Service",
        "ja": "AIスマートカスタマーサービス",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C4.jpg",
        "detail_content": {
            "zh": {
                "title": "AI智慧客服",
                "subt1": "適用場域",
                "subl1": ["停車場", "金融機構", "電信公司", "旅遊與酒店業", "客戶服務中心", "公共服務機構"],
                "subt2": "使用技術",
                "subl2": ["語音識別", "自然語言處理（NLP）", "大型語言模型（LLM）", "語音合成", "聊天機器人", "大數據分析", "即時通訊技術"],
                "subt3": "現有痛點",
                "subc3": "傳統客服系統依賴大量人工，成本高且效率低。客戶服務質量不一，受客服人員情緒和經驗影響。高峰時段容易出現客服人力不足，導致客戶等待時間過長。",
                "subt4": "方案說明",
                "subc4": "Nexuni的AI智慧客服系統利用自然語言處理和機器學習技術，為企業提供高效、智能的客戶服務。系統配備智能聊天機器人，即時回應客戶諮詢，處理常見問題，提供全天候服務，減少人工客服工作量。語音識別與合成技術實現語音交流，提升客戶體驗。機器學習技術不斷優化系統回應準確性，確保準確理解和回答客戶需求。大數據分析技術幫助企業即時了解客戶需求和反饋，提供數據支持，優化服務策略。"
            },
            "en": {
                "title": "Artificial Intelligence Customer Service",
                "subt1": "Applicable Areas",
                "subl1": ["Parking Lots", "Financial Institutions", "Telecom Companies", "Tourism and Hotel Industry", "Customer Service Centers", "Public Service Agencies"],
                "subt2": "Technologies",
                "subl2": ["Speech Recognition", "Natural Language Processing (NLP)", "Large Language Models (LLM)", "Speech Synthesis", "Chatbots", "Big Data Analysis", "Real-time Communication Technology"],
                "subt3": "Current Issues",
                "subc3": "Traditional customer service systems are labor-intensive, driving up costs and lowering efficiency. Service quality fluctuates based on personnel emotions and experience. Peak hours often see understaffing, leading to lengthy wait times. Real-time analysis of customer service data is challenging, affecting customer experience and service enhancements.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's AI Customer Service system uses advanced natural language processing and machine learning to provide efficient and intelligent customer solutions. Intelligent chatbots address inquiries swiftly, reducing manual workload and offering 24/7 service. Voice communication is enhanced through speech recognition and synthesis. Continuous machine learning improves response accuracy. Real-time big data analysis helps understand customer needs and feedback, optimizing service strategies. The system seamlessly connects with human representatives, transferring queries when needed for comprehensive issue resolution."
            },
            "ja": {
                "title": "AIスマートカスタマーサービス",
                "subt1": "適用分野",
                "subl1": ["駐車場", "金融機関", "電気通信会社", "観光およびホテル業", "カスタマーサービスセンター", "公共サービス機関"],
                "subt2": "使用技術",
                "subl2": ["音声認識", "自然言語処理（NLP）", "大型言語モデル（LLM）", "音声合成", "チャットボット", "ビッグデータ分析", "即時通信技術"],
                "subt3": "現行の課題",
                "subc3": "従来のカスタマーサービスシステムは大量の人手に依存しており、コストが高く、効率が低い。カスタマーサービスの質は人員の感情や経験に左右される。ピーク時にはカスタマーサービスの人員が不足しがちで、顧客の待ち時間が長くなる。",
                "subt4": "解決策の説明",
                "subc4": "NexuniのAIスマートカスタマーサービスシステムは、先進的な自然言語処理と機械学習技術を利用して、企業に効率的でインテリジェントなカスタマーサービスソリューションを提供します。システムにはインテリジェントチャットボットが搭載されており、顧客の問い合わせに即座に対応し、一般的な問題を処理し、24時間365日のサービスを提供することで、人工カスタマーサービスの作業負担を大幅に軽減します。音声認識と音声合成技術により、AIスマートカスタマーサービスは音声でのやり取りが可能になり、顧客とのインタラクション体験を向上させます。機械学習は応答の精度を継続的に最適化および向上させ、顧客のさまざまなニーズを正確に理解し、回答できるようにします。ビッグデータ分析は、企業が顧客のニーズとフィードバックを即座に分析し、理解するのに役立ち、サービス戦略の最適化のためのデータサポートを提供します。"
            }
        }
    },
    {
        "zh": "餐飲店面POS系統",
        "en": "Restaurant POS System",
        "ja": "レストランPOSシステム",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C5.jpg",
        "detail_content": {
            "zh": {
                "title": "餐飲店面POS系統",
                "subt1": "適用場域",
                "subl1": ["餐廳", "咖啡廳", "速食店", "自助餐廳", "餐飲連鎖店"],
                "subt2": "使用技術",
                "subl2": ["庫存計算系統", "友善使用者介面", "外送平台串接系統", "多項支付串接系統"],
                "subt3": "現有痛點",
                "subc3": "傳統收費系統依賴大量人工，成本高且效率低。支付方式單一，營業管理數據複雜，不易整理，庫存監控困難，外送平台單子內容項目多，容易出錯。",
                "subt4": "方案說明",
                "subc4": "Nexuni的餐飲店面POS系統旨在為餐飲業提供全方位的解決方案。該系統結合移動支付功能，支持多種支付方式，提升交易速度和顧客滿意度，降低人工出錯率。後端系統利用大數據分析，實現銷售數據的實時更新和分析，幫助管理者更好地監控和管理庫存。該系統不僅提高了收銀效率，還簡化了數據管理流程，提升餐飲店面的運營效率和盈利能力。"
            },
            "en": {
                "title": "Restaurant POS System",
                "subt1": "Applicable Areas",
                "subl1": ["Restaurants", "Cafes", "Fast Food joints", "Buffets", "Restaurant Chains"],
                "subt2": "Technologies",
                "subl2": ["Inventory Calculation System", "User-friendly Interface", "Delivery Platform Integration System", "Multiple Payment Integration Systems"],
                "subt3": "Current Issues",
                "subc3": "Traditional billing systems rely heavily on manual processes, resulting in high costs and low efficiency. Limited payment options. Complexity in business management data, making organization difficult. Difficulties in inventory monitoring, inability to track stock movements accurately. Orders from delivery platforms often have multiple items, leading to errors.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's Restaurant Point of Sale (POS) system is designed to revolutionize the restaurant industry. It integrates mobile payment options, supporting various methods for faster transactions and improved customer satisfaction, while reducing errors. The backend system employs big data analysis for real-time updates and sales data analysis, facilitating better inventory management for managers. By enhancing cashier efficiency and streamlining data management, this system significantly boosts operational efficiency and profitability for restaurant establishments."
            },
            "ja": {
                "title": "レストランPOSシステム",
                "subt1": "適用分野",
                "subl1": ["レストラン", "カフェ", "ファストフード店", "ビュッフェ", "レストランチェーン"],
                "subt2": "使用技術",
                "subl2": ["在庫計算システム", "ユーザーフレンドリーなインターフェース", "デリバリープラットフォーム統合システム", "複数の支払い統合システム"],
                "subt3": "現行の課題",
                "subc3": "従来の請求システムは手動作業に大きく依存しており、コストが高く、効率が低い。支払い方法が限られており、ビジネス管理データが複雑で整理が難しい。 在庫監視が困難で、デリバリープラットフォームの注文には多くの項目があり、エラーが発生しやすい。",
                "subt4": "解決策の説明",
                "subc4": "NexuniのレストランPOSシステムは、食品および飲料業界に包括的なソリューションを提供することを目的としています。このシステムはモバイル支払い機能を統合し、複数の支払い方法をサポートして、取引速度と顧客満足度を向上させると同時に、人的エラー率を低減します。バックエンドシステムはビッグデータ分析を使用して、販売データのリアルタイム更新と分析を実現し、管理者が在庫をよりよく監視および管理できるようにします。このシステムは、チェックアウト効率を向上させるだけでなく、データ管理プロセスを簡素化し、レストランの運営効率と収益性を向上させます。"
            }
        }
    },
    {
        "zh": "RFID物流管理系統",
        "en": "RFID Logistics Management System",
        "ja": "RFID物流管理システム",
        "group_tag": ["id1", "id4"],
        "img_url": "/assets/solution/C6.jpg",
        "detail_content": {
            "zh": {
                "title": "RFID物流管理系統",
                "subt1": "適用場域",
                "subl1": ["倉庫管理", "運輸物流", "供應鏈管理", "生產製造業", "零售業", "電商平台"],
                "subt2": "使用技術",
                "subl2": ["RFID", "無線通訊技術", "PDA串接"],
                "subt3": "現有痛點",
                "subc3": "貨物追蹤困難，庫存管理不準確，人工操作誤差高，庫存數據更新不及時，運輸過程中貨物丟失，責任歸屬問題。",
                "subt4": "方案說明",
                "subc4": "Nexuni的RFID物流管理系統運用RFID及無線通訊技術，為物流業提供高效解決方案。每個貨物附有RFID標籤，並使用PDA掃描後裝入物流箱，從倉庫到最終目的地的每個環節均可實時監控，減少人工操作誤差，優化庫存管理。系統顯著提高物流管理效率，降低營運成本，提升流程可靠性。"
            },
            "en": {
                "title": "RFID Logistics Management System",
                "subt1": "Applicable Areas",
                "subl1": ["Warehouse Management", "Transportation Logistics", "Supply Chain Management", "Manufacturing Industry", "Retail Industry", "E-commerce Platforms"],
                "subt2": "Technologies",
                "subl2": ["RFID", "Wireless Communication Technology", "PDA Integration"],
                "subt3": "Current Issues",
                "subc3": "Difficulty in tracking goods, inaccurate inventory management, high manual operation errors, delayed updates in inventory data, and loss of goods during transportation with unclear responsibility.",
                "subt4": "Solution Description",
                "subc4": "Nexuni's RFID Logistics Management System utilizes RFID and wireless communication technology to provide an efficient solution for the chain retail industry. Each return box is equipped with an RFID tag, and after scanning the returned items with a PDA, they are placed into the return box. Every step from the warehouse to the final destination is monitored in real-time. This system reduces human error in operations and optimizes inventory management. It significantly enhances logistics management efficiency, reduces operational costs, and improves process reliability."
            },
            "ja": {
                "title": "RFID物流管理システム",
                "subt1": "適用分野",
                "subl1": ["倉庫管理", "輸送物流", "サプライチェーン管理", "製造業", "小売業", "eコマースプラットフォーム"],
                "subt2": "使用技術",
                "subl2": ["RFID", "無線通信技術", "PDA統合"],
                "subt3": "現行の課題",
                "subc3": "商品の追跡が困難で、在庫管理が不正確であり、手動操作エラーが多く、在庫データの更新が遅れており、輸送中の商品紛失の責任が不明確である。",
                "subt4": "解決策の説明",
                "subc4": "NexuniのRFID物流管理システムは、RFIDと無線通信技術を使用して、物流業界に効率的なソリューションを提供します。各商品にはRFIDタグが付けられ、PDAを使用してアイテムをスキャンし、物流ボックスにロードする前にスキャンします。これにより、倉庫から最終目的地までのすべての段階でリアルタイムの監視が可能になり、手動操作エラーが減少し、在庫管理が最適化されます。このシステムは、物流管理の効率を大幅に向上させ、運用コストを削減し、プロセスの信頼性を向上させます。"
            }
        }
    }]
        },
        {
        "title": {
            "zh": "AI工廠自動化",
            "en": "AI Factory Automation",
            "ja": "AI工場",
            "color": "#63D474",
            "group_tag": ["id1", "id5"]
        },
        "content": [
            {
                "zh": "AI協作型機器人應用",
                "en": "AI Collaborative Robot Applications",
                "ja": "AI協働ロボット応用",
                "group_tag": ["id1", "id5"],
                "img_url": "/assets/solution/D2.jpg",
                "detail_content": {
                    "zh": {
                        "title": "AI協作型機器人應用",
                        "subt1": "適用場域",
                        "subl1": ["粉塵及光線危害環境", "大型流水線", "物流和倉儲管理", "工廠裝配作業", "醫療的輔助手術", "實驗室自動化", "科技農業"],
                        "subt2": "使用技術",
                        "subl2": ["深度攝影機", "AI視覺辨識", "力覺傳感器", "位置傳感器", "閉環控制系統", "協同控制", "路徑規劃和優化", "直觀編程界面", "碰撞檢測"],
                        "subt3": "現有痛點",
                        "subc3": "現有生產線依賴大量人力，面臨工人疲勞、錯誤率高、效率低以及勞動力成本上升等問題。導入機械手臂後，生產效率和產品質量顯著提高。機械手臂能夠24/7不間斷運行，完成高精度和一致性的操作，從而提高生產效率並確保每個產品的高質量，減少因人為因素造成的誤差。此外，自動化減少了對人力的依賴，降低了勞動力成本和次品率，進而降低了整體生產成本。通過快速編程和多功能性，機械手臂使生產線能夠靈活適應不同產品的需求，提升了市場反應速度和企業競爭力，進一步鞏固了技術領先地位。",
                        "subt4": "方案說明",
                        "subc4": "Nexuni的智慧協作型機器手臂系統與業界領先的Universal Robots合作，提供具有高效精準手臂，並將NXAI框架應用在上面，該系統使用先進的圖像識別模型進行邊緣運算，可準確判斷並執行生產線上的各種操作，同時可提供更多數據進行生產管理分析。智慧協作型機器手臂系統不僅安裝方便，而且識別率高，能準確執行即時操作狀態，並且可升級加入更多智能功能。"
                    },
                    "en": {
                        "title": "AI Collaborative Robot Applications",
                        "subt1": "Applicable Areas",
                        "subl1": ["Dust and Light Hazard Environments", "Large Assembly Lines", "Logistics and Warehousing Management", "Factory Assembly Operations", "Medical Assistance Surgeries", "Laboratory Automation", "Technological Agriculture"],
                        "subt2": "Technologies",
                        "subl2": ["Depth Cameras", "AI Vision Recognition", "Force Sensors", "Position Sensors", "Closed-loop Control System", "Collaborative Control", "Path Planning and Optimization", "Intuitive Programming Interface", "Collision Detection"],
                        "subt3": "Current Issues",
                        "subc3": "Current production lines heavily rely on manual labor, leading to challenges like worker fatigue, high error rates, and rising costs. The integration of robotic arms has revolutionized operations by working continuously with high precision and consistency, improving efficiency and product quality. Automation reduces labor reliance, cutting costs and defect rates. Rapid programming and versatility allow production lines to quickly adapt to different product needs, enhancing market responsiveness and competitiveness, and solidifying technological leadership.",
                        "subt4": "Solution Description",
                        "subc4": "Nexuni's Smart Collaborative Robotic Arm System, developed in partnership with Universal Robots, leverages the NXAI framework to enhance performance. This system utilizes advanced image recognition models for edge computing, ensuring precise and efficient operations on the production line while offering valuable data for management analysis. Easy to install and boasting high recognition rates, it executes real-time operations accurately and can be upgraded with additional intelligent functions."
                    },
                    "ja": {
                        "title": "AI協働ロボット応用",
                        "subt1": "適用分野",
                        "subl1": ["粉塵および光線危害環境", "大型アセンブリライン", "物流および倉庫管理", "工場組立作業", "医療補助手術", "実験室自動化", "テクノロジー農業"],
                        "subt2": "使用技術",
                        "subl2": ["深度カメラ", "AIビジョン認識", "フォースセンサー", "位置センサー", "クローズドループ制御システム", "協調制御", "経路計画と最適化", "直感的なプログラミングインターフェース", "衝突検出"],
                        "subt3": "現行の課題",
                        "subc3": "現行の生産ラインは大量の手作業に依存しており、労働者の疲労、高いエラー率、低効率、および労働コストの上昇などの問題に直面しています。ロボットアームを導入することで、生産効率と製品品質が大幅に向上します。ロボットアームは24/7連続稼働し、高精度で一貫した操作を行うことで、生産効率を向上させ、人為的なエラーを減らしながら高品質な製品を確保します。また、自動化により手作業への依存が減り、労働コストと欠陥率が低下し、結果として総生産コストが削減されます。迅速なプログラミングと多機能性により、ロボットアームはさまざまな製品の要求に柔軟に対応し、市場の反応速度と競争力を高め、技術的なリーダーシップをさらに強化します。",
                        "subt4": "解決策の説明",
                        "subc4": "Nexuniのスマート協働ロボットアームシステムは、業界のリーダーであるUniversal Robotsと協力して、高効率で精密なアームを提供し、NXAIフレームワークを適用しています。システムは、エッジコンピューティングのために先進的な画像認識モデルを使用し、生産ライン上のさまざまな操作を正確に識別および実行し、同時に生産管理分析のためのより多くのデータを提供します。スマート協働ロボットアームシステムは、設置が簡単で、高い認識率を持ち、リアルタイムの操作を正確に実行し、より多くのインテリジェントな機能を追加してアップグレードすることができます。"
                    }
                }
            },
            {
                "zh": "AI食品產線績效評估",
                "en": "AI Food Production Line Performance Evaluation",
                "ja": "AI食品生産ラインパフォーマンス評価",
                "group_tag": ["id1", "id5"],
                "img_url": "/assets/solution/D3.jpg",
                "detail_content": {
                    "zh": {
                        "title": "AI食品產線績效評估",
                        "subt1": "適用場域",
                        "subl1": ["水產加工廠", "食品加工廠", "鮮魚批發市場", "超市中央廚房", "相關食品製造企業"],
                        "subt2": "使用技術",
                        "subl2": ["多串流即時處理", "影像分析技術", "物體識別", "深度學習", "追蹤技術", "數據分析"],
                        "subt3": "現有痛點",
                        "subc3": "傳統產線績效評估依賴人工記錄，容易出現錯誤和遺漏，難以精確反映員工的工作效率。管理者無法即時掌握產線各員工的工作狀態，難以有效進行調度和管理。缺乏科學的數據支持，績效評估和獎懲制度難以公平公正。員工工作效率和產線運作情況難以即時反映，影響整體生產效率和品質。",
                        "subt4": "方案說明",
                        "subc4": "Nexuni的鮭魚產線績效評估系統利用頂頭攝影機和先進的影像分析技術，實時監控和記錄產線各員工的工作情況。通過影像分析和物體識別技術，系統自動計算每位員工在特定時間內切割的鮭魚數量，並將數據傳送至中央管理平台。利用深度學習技術，系統準確識別和記錄每位員工的操作細節，生成詳細的工作效率報告，幫助管理者評估員工的工作績效。大數據分析技術的應用讓管理者全面了解產線運作情況，優化生產流程。同時，系統提供即時監控功能，讓管理者即時掌握各個產線的運作狀態，進行有效的調度和管理，提升生產效率和產品品質。該系統還能生成具體的績效報告，支持公平公正的獎懲制度，激勵員工提升工作效率。"
                    },
                    "en": {
                        "title": "AI Food Production Line Performance Evaluation",
                        "subt1": "Applicable Areas",
                        "subl1": ["Seafood Processing Plants", "Food Processing Plants", "Fish Wholesale Markets", "Supermarket Central Kitchens", "Manufacturing Companies"],
                        "subt2": "Technologies",
                        "subl2": ["Multi-stream Real-time Processing", "Image Analysis Technology", "Object Recognition", "Deep Learning", "Tracking Technology", "Data Analysis"],
                        "subt3": "Current Issues",
                        "subc3": "Traditional production line performance evaluation relies on manual recording, prone to errors and omissions, hindering accurate assessment of employee efficiency. Real-time monitoring of employees is lacking, impeding effective scheduling and management. Without scientific data support, implementing fair performance evaluations and reward systems is challenging. As a result, employee efficiency and production line operations are not promptly reflected, adversely affecting overall production efficiency and quality.",
                        "subt4": "Solution Description",
                        "subc4": "Nexuni's salmon production line evaluation system uses overhead cameras and advanced image analysis to monitor and record employee performance in real-time. Object recognition and deep learning calculate salmon cuts per worker, sending data to a central platform for detailed efficiency reports. Big data analytics optimize production processes, while real-time monitoring allows for effective management and scheduling. The system generates performance reports to support fair rewards, motivating employees to enhance efficiency."
                    },
                    "ja": {
                        "title": "AI食品生産ラインパフォーマンス評価",
                        "subt1": "適用分野",
                        "subl1": ["水産加工工場", "食品加工工場", "鮮魚卸売市場", "スーパーマーケットのセントラルキッチン", "関連食品製造企業"],
                        "subt2": "使用技術",
                        "subl2": ["マルチストリームリアルタイム処理", "画像解析技術", "物体認識", "深層学習", "追跡技術", "データ分析"],
                        "subt3": "現行の課題",
                        "subc3": "従来の生産ラインパフォーマンス評価は手動記録に依存しており、エラーや抜けが発生しやすく、従業員の作業効率を正確に反映することが難しいです。マネージャーは生産ラインの各従業員の作業状況をリアルタイムで把握できず、効果的なスケジュール管理が困難です。科学的なデータサポートが不足しているため、パフォーマンス評価と報酬・罰則制度が公平公正に行われることが難しいです。従業員の作業効率や生産ラインの運用状況がリアルタイムで反映されないため、全体的な生産効率と品質に影響を与えます。",
                        "subt4": "解決策の説明",
                        "subc4": "Nexuniの鮭生産ラインパフォーマンス評価システムは、オーバーヘッドカメラと先進的な画像解析技術を使用して、生産ラインの各従業員の作業状況をリアルタイムで監視および記録します。システムは画像解析と物体認識技術を使用して、特定の時間内に各従業員が切った鮭の数を自動的に計算し、データを中央管理プラットフォームに送信します。深層学習技術を使用して、システムは各従業員の操作の詳細を正確に識別および記録し、マネージャーが従業員のパフォーマンスを正確に評価するのに役立つ詳細な作業効率レポートを生成します。ビッグデータ分析技術の応用により、マネージャーは履歴データとリアルタイムデータに基づいて、生産ラインの運用状況を包括的に理解し、生産プロセスを最適化できます。また、システムはリアルタイム監視機能を提供し、マネージャーが各生産ラインの運用状況を把握し、効果的にスケジュール管理を行い、全体的な生産効率と製品品質を向上させます。このシステムは具体的なパフォーマンスレポートを生成し、公平公正な報酬・罰則制度をサポートし、従業員の作業効率向上を促します。"
                    }
                }
            },
            {
                "zh": "半導體工廠機台流程自動化(RPA)",
                "en": "Semiconductor Factory Machine Process Automation (RPA)",
                "ja": "半導体工場機械プロセス自動化(RPA)",
                "group_tag": ["id1", "id5"],
                "img_url": "/assets/solution/D4.jpg",
                "detail_content": {
                    "zh": {
                        "title": "半導體工廠機台流程自動化(RPA)",
                        "subt1": "適用場域",
                        "subl1": ["半導體生產線", "大型流水線", "醫療的輔助手術", "實驗室自動化"],
                        "subt2": "使用技術",
                        "subl2": ["串流即時處理", "影像分析技術", "深度學習", "追蹤技術", "數據分析"],
                        "subt3": "現有痛點",
                        "subc3": "許多生產線工廠因為現有機台的限制，無法順利導入自動化生產，導致效率無法提升。此外，受限於API等技術的限制，現有設備與自動化系統之間無法進行無縫整合，使得生產過程中出現瓶頸。這些技術限制不僅降低了生產效率，也增加了運營成本，並限制了企業在競爭激烈的市場中保持競爭力的能力。",
                        "subt4": "方案說明",
                        "subc4": "針對這些挑戰，Nexuni 提供一個創新的桌面截圖技術，能夠在微型修改硬體的情況下，滿足自動化的需求。我們的解決方案能夠在不更換現有機台的情況下，通過軟硬體的微調和整合，使得生產設備與自動化系統無縫對接。這不僅解決了技術限制問題，還顯著提升了生產效率和靈活性，幫助企業實現智慧轉型並在市場中保持競爭力。Nexuni 致力於提供定制化的解決方案，幫助企業克服技術障礙，實現自動化生產的目標。"
                    },
                    "en": {
                        "title": "Semiconductor Factory Machine Process Automation (RPA)",
                        "subt1": "Applicable Areas",
                        "subl1": ["Semiconductor Production Lines", "Large Assembly Lines", "Medical Assistance Surgeries", "Laboratory Automation"],
                        "subt2": "Technologies",
                        "subl2": ["Real-time Stream Processing", "Image Analysis Technology", "Deep Learning", "Tracking Technology", "Data Analysis"],
                        "subt3": "Current Issues",
                        "subc3": "Factories struggle to automate due to outdated machinery, leading to inefficiency. Also, tech limitations like APIs hinder equipment integration, causing production slowdowns. These hurdles lower efficiency and raise costs, making competition tough.",
                        "subt4": "Solution Description",
                        "subc4": "Nexuni offers an innovative solution: a magic desktop screenshot tool! It tweaks hardware just a bit, allowing seamless equipment integration with automation systems. No need for new machines! This boosts efficiency and flexibility, aiding enterprises in staying smart and competitive. Nexuni's on a mission to bust tech barriers and make automated production dreams come true!"
                    },
                    "ja": {
                        "title": "半導体工場機械プロセス自動化(RPA)",
                        "subt1": "適用分野",
                        "subl1": ["半導体生産ライン", "大型アセンブリライン", "医療補助手術", "実験室自動化"],
                        "subt2": "使用技術",
                        "subl2": ["リアルタイムストリーム処理", "画像解析技術", "深層学習", "追跡技術", "データ分析"],
                        "subt3": "現行の課題",
                        "subc3": "多くの生産ライン工場は、既存の機械の制限により、自動化生産の導入がスムーズに進まず、効率が向上しません。また、APIなどの技術の制限により、既存の設備と自動化システムの間でシームレスな統合ができず、生産プロセスにボトルネックが発生しています。これらの技術的制限は、生産効率を低下させるだけでなく、運用コストを増加させ、競争の激しい市場で企業が競争力を維持する能力を制限します。",
                        "subt4": "解決策の説明",
                        "subc4": "これらの課題に対処するために、Nexuniは最小限のハードウェア変更で自動化のニーズを満たす革新的なデスクトップスクリーンショット技術を提供します。私たちのソリューションは、既存の機械を交換せずに、ソフトウェアとハードウェアの微調整を通じて、生産設備と自動化システムの間でシームレスな統合を実現します。これにより、技術的制限が解決されるだけでなく、生産効率と柔軟性が大幅に向上し、企業がスマートな変革を実現し、市場で競争力を維持するのに役立ちます。Nexuniは、企業が技術的な障害を克服し、自動化生産の目標を達成するのを支援するカスタマイズされたソリューションの提供に専念しています。"
                    }
                }
            }
        ]
    },
    {
        "title": {
            "zh": "技術服務",
            "en": "Technical Services",
            "ja": "技術サービス",
            "color": "#EF7350",
            "group_tag": ["id1", "id6"]
        },
        "content": [
            {
                "zh": "AI自動化系統客製化研發",
                "en": "AI Automation System Custom Development",
                "ja": "AI自動化システムカスタム開発",
                "group_tag": ["id1", "id6"],
                "img_url": "/assets/solution/E1.jpg",
                "detail_content": {
                    "zh": {
                        "title": "AI自動化系統客製化研發",
                        "subt1": "適用場域",
                        "subl1": ["所有需要AI自動化的企業"],
                        "subt2": "使用技術",
                        "subl2": ["AI人工智慧", "機器人", "物聯網", "自動化系統"],
                        "subt3": "方案說明",
                        "subc3": "Nexuni致力於提供尖端的AI自動化解決方案，幫助企業提升效率、降低成本並實現智慧轉型。我們的技術專長涵蓋多個領域，能夠針對企業需求提供定制化的解決方案。以下是我們的關鍵技術：<br><br>深度攝影機：利用高精度深度攝影技術實現精確的3D掃描和測量，適用於質量檢測、安防監控等應用。<br>AI視覺辨識：通過先進的圖像處理和機器學習算法，我們的AI視覺辨識系統能夠實現自動檢測、識別和分類。<br>自動機械手臂：作為Universal Robots認證的Solution Provider，我們的自動機械手臂系統具備高度靈活性和精確度，適用於自動化裝配、物料搬運、包裝等多種工業應用。<br>嵌入式系統：我們的嵌入式系統技術為系統提供高度穩定和定制化的解決方案，適用於工業自動化、智能家居、醫療設備等多種應用。這些系統能夠實現高效能和低功耗，並且能夠與其他系統無縫對接，提升整體運作效率和可靠性。",
                        "subt4": "",
                        "subc4": ""
                    },
                    "en": {
                        "title": "AI Automation System Custom Development",
                        "subt1": "Applicable Areas",
                        "subl1": ["All enterprises requiring AI automation"],
                        "subt2": "Technologies",
                        "subl2": ["AI", "Robotics", "IoT", "Automation Systems"],
                        "subt3": "Solution Description",
                        "subc3": "Nexuni is committed to providing advanced AI automation solutions to help businesses improve efficiency, reduce costs, and achieve intelligent transformation. Our technical expertise covers multiple domains, allowing us to offer customized solutions tailored to the needs of enterprises. Through the following key technologies, we assist clients in solving problems:<br><br>1. Depth Cameras: Utilizing high-precision depth camera technology, we achieve accurate 3D scanning and measurement suitable for applications such as quality inspection and security monitoring.<br>2. AI Visual Recognition: Through advanced image processing and machine learning algorithms, our AI visual recognition system can automatically detect, identify, and classify objects.<br>3. Automatic Robotic Arms: As a certified Solution Provider for Universal Robots, we employ automatic robotic arm systems that offer high flexibility and precision, suitable for various industrial applications including automated assembly, material handling, and packaging.<br>4. Embedded Systems: Our embedded system technology provides highly stable and customized solutions for applications such as industrial automation, smart homes, and medical devices. Embedded systems enable high performance and low power consumption while seamlessly integrating with other systems to enhance overall operational efficiency and reliability."
                        ,
                        "subt4": "",
                        "subc4": ""
                    },
                    "ja": {
                        "title": "AI自動化システムカスタム開発",
                        "subt1": "適用分野",
                        "subl1": ["AI自動化を必要とするすべての企業"],
                        "subt2": "使用技術",
                        "subl2": ["AI", "ロボット工学", "IoT", "自動化システム"],
                        "subt3": "解決策の説明",
                        "subc3": "Nexuniは、企業が効率を向上させ、コストを削減し、スマートな変革を実現するのを支援する最先端のAI自動化ソリューションを提供することに専念しています。当社の技術専門知識は複数の分野にわたり、企業のニーズに基づいてカスタマイズされたソリューションを提供することができます。以下の主要な技術を通じて、顧客が問題を解決するのを支援します: 深度カメラ: 高精度の深度カメラ技術を利用して、品質検査、セキュリティ監視などの用途において正確な3Dスキャンと測定を実現します。AIビジョン認識: 高度な画像処理および機械学習アルゴリズムを通じて、AIビジョン認識システムは自動検出、認識、および分類を実現します。自動ロボットアーム: Universal Robotsの認定ソリューションプロバイダーとして、Nexuniは高い柔軟性と精度を備えた自動ロボットアームシステムを提供し、自動組立、物品取扱い、包装などのさまざまな産業用途に適しています。組み込みシステム: 当社の組み込みシステム技術は、産業自動化、スマートホーム、医療機器などの用途において、高度に安定したカスタマイズ可能なソリューションを提供します。組み込みシステムは高性能と低消費電力を実現し、他のシステムとシームレスにインターフェースし、全体的な運用効率と信頼性を向上させます。",
                        "subt4": "",
                        "subc4": ""
                    }
                }
            },
            {
                "zh": "Universal Robots 協作型機器人認證夥伴",
                "en": "Universal Robots Collaborative Robot Certified Partner",
                "ja": "Universal Robots 協働ロボット認定パートナー",
                "group_tag": ["id1", "id6"],
                "img_url": "/assets/solution/E2.jpg",
                "detail_content": {
                    "zh": {
                      "title": "Universal Robots 協作型機器人認證夥伴",
                      "subt1": "適用場域",
                      "subl1": ["所有需要AI自動化的企業"],
                      "subt2": "使用技術",
                      "subl2": ["Universal Robot 解決方案研發"],
                      "subt3": "方案說明",
                      "subc3": "Nexuni 是 Universal Robots 認證的 Solution Provider 以及 Distributor，專注於提供尖端的AI自動化解決方案。我們利用高精度深度攝影機技術、先進的AI視覺辨識系統和自動機械手臂，協助企業提升效率、降低成本並實現智慧轉型。此外基於供嵌入式系統跟協作機器手臂的技術結合技術，為工業自動化、智能家居和醫療設備等多種應用提供穩定且高度整合和定制化的解決方案。我們致力於滿足企業的各種需求，幫助客戶解決複雜問題並提升整體運作效率和可靠性。",
                      "subt4": "",
                      "subc4": ""
                  },
                  "en": {
                      "title": "Universal Robots Collaborative Robot Certified Partner",
                      "subt1": "Applicable Areas",
                      "subl1": ["All enterprises requiring AI automation"],
                      "subt2": "Technologies",
                      "subl2": ["Universal Robot Solution Development"],
                      "subt3": "Solution Description",
                      "subc3": "Nexuni is a certified Solution Provider and distributor for Universal Robots, specializing in providing cutting-edge AI automation solutions. We utilize high-precision depth camera technology, advanced AI visual recognition systems, and automatic robotic arms to help businesses improve efficiency, reduce costs, and achieve intelligent transformation. Additionally, leveraging our expertise in embedded systems and collaborative robot arms, we offer stable, highly integrated, and customized solutions for various applications including industrial automation, smart homes, and medical devices. We are dedicated to meeting the diverse needs of enterprises, assisting clients in solving complex problems, and enhancing overall operational efficiency and reliability.",
                      "subt4": "",
                      "subc4": ""
                  },
                  "ja": {
                      "title": "Universal Robots 協働ロボット認定パートナー",
                      "subt1": "適用分野",
                      "subl1": ["AI自動化を必要とするすべての企業"],
                      "subt2": "使用技術",
                      "subl2": ["Universal Robotソリューション開発"],
                      "subt3": "解決策の説明",
                      "subc3": "Nexuniは、Universal Robotsの認定ソリューションプロバイダーおよび代理店であり、最先端のAI自動化ソリューションの提供に注力しています。高精度の深度カメラ技術、高度なAIビジョン認識システム、および自動ロボットアームを活用して、企業の効率を向上させ、コストを削減し、スマートな変革を実現します。さらに、組み込みシステムと協働ロボットアーム技術を統合することにより、産業自動化、スマートホーム、医療機器などの用途に対して、安定した高度に統合されたカスタマイズソリューションを提供します。私たちは企業の多様なニーズに応え、顧客が複雑な問題を解決し、全体的な運用効率と信頼性を向上させることに専念しています。",
                      "subt4": "",
                      "subc4": ""
                  }
                }
            }
        ]
    }
      ]
    }

    this.general_switch_page = this.general_switch_page.bind(this)
    this.update_lang = this.update_lang.bind(this)
    this.update_card_status = this.update_card_status.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(current_lang) {
    this.setState({
      lang: current_lang
    }, () => {
      console.log(this.state.lang)
    })
  }

  update_card_status(status, _data, img) {
    if (status === "open") {
      this.setState({
        card_display: "",
        card_content: { ..._data, "img_url": img}
      })
    }
    else {
      this.setState({
        card_display: "v2_display_none",
        card_content: null
      })
    }
  }

  general_switch_page(path, data) {
    if (path !== "/SolutionPage" || path !== "/") {
      setCookie("lang", this.state.lang)
      window.location.href = path + "?page=" + data
    }
    else {
      // pass
    }
  }

  sort_func(_id) {
    this.setState({
      current_cat: _id
    })
  }


  render() {
        return (
          <div className={this.state.lang+" solution_page"} >
            <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />
            <SolutionNavBar lang={this.state.lang} title={this.state.category.title} content={this.state.category.content} sort_func={(_id) => {this.sort_func(_id)}}/>
            {this.state.content.map(item => 
              (item["title"]["group_tag"].includes(this.state.current_cat) ? <SolutionSection lang={this.state.lang} title={item["title"]} content={item["content"]} update_card_status={this.update_card_status} current_cat={this.state.current_cat}/> : <></>))}
            <PopupCard className={this.state.card_display} card_content={this.state.card_content} update_card_status={this.update_card_status}/>
            <Footer lang={this.state.lang} general_switch_page={this.general_switch_page}/>
          </div>
        ) 
  }

}

class SolutionNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: this.props.title,
      content: this.props.content
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  nav_btn_function(_id) {
    this.props.sort_func(_id)
  }

  render() {
    return (
      <div className="solution_nav_section">
        <p className="nav_btn_title">{this.state.title[this.state.lang]}</p>
        <div className="nav_section_holder">
          {this.state.content.map((item) => <div className="nav_btn" onClick={() => {this.nav_btn_function(item["id"])}}>{item[this.state.lang]}</div>)}
        </div>
      </div>
    )
  }
}


class SolutionSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: this.props.title,
      content: this.props.content,
      current_cat: this.props.current_cat
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
    if (nextProps.current_cat !== this.state.current_cat) {
      this.setState({ current_cat: nextProps.current_cat });
    }
  }

  render() {
    return (
      <>
        <div className="solution_title_section">
          <h2 style={{color: this.state.title["color"]}} >{this.state.title[this.state.lang]}</h2>
        </div>
        <div className="solution_section">
          {this.state.content.map((item) => (item["group_tag"].includes(this.state.current_cat) ? <SolutionCard color={this.state.title["color"]} lang={this.state.lang} img_url={item["img_url"]} content={item} onClick={() => this.props.update_card_status("open", item["detail_content"][this.state.lang], item["img_url"])}/> : <></>))}
        </div>
      </>
    )
  }
}


class SolutionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      name: this.props.content,
      img_url: this.props.img_url !== "" ? this.props.img_url : "/assets/mainpage_home1.webp",
      status: "DETAIL"
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {
    return (
      <div className="solution_card" onClick={this.props.onClick}>
        <div className="img_section" style={{backgroundColor: this.props.color}}>
          <img src={this.state.img_url} />
        </div>
        <div className="solution_card_info">
          <h2>{this.state.name[this.state.lang]}</h2>
          <span>{this.state.status} ></span>
        </div>
      </div>
    )
  }
}

class PopupCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      status: "DETAIL",
      card_content: this.props.card_content,
      card_flag: true
    }

    console.log("this.props.card_content: ", this.props.card_content)
    this.closeWin = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
    else if (nextProps.card_content !== this.state.card_content) {
      this.setState({ card_content: nextProps.card_content });
    }
  }

  render() {
    return (
      <div className={"v2_solution_pop_up_bg "+this.props.className} onClick={() => {this.state.card_flag ? this.props.update_card_status("close") : this.setState({card_flag: true})}}>
        <div className="v2_solution_pop_up_card" onClick={() => this.state.card_flag = false}>
          <div className="v2_solution_pop_up_card_img_section">
            <img src={this.state.card_content ? this.state.card_content["img_url"] : "https://images.unsplash.com/photo-1522770179533-24471fcdba45"} />
            <div className="v2_solution_pop_up_card_info_title">
              <h1>{this.state.card_content ? this.state.card_content["title"] : ""}</h1>
            </div>
            <div className="v2_solution_pop_up_card_info_section1">
              <div className="v2_pop_info_section1_list_holder">
                <h2>{this.state.card_content ? this.state.card_content["subt1"] : ""}</h2>
                <hr />
                <div className="v2_pop_info_section1_list">
                  {this.state.card_content ? this.state.card_content["subl1"].map(item => 

                    <div className="v2_pop_info_section1_list_item">
                      <span className="v2_cube"></span>
                      <p>{item}</p>
                    </div>)

                   : <></>}
                </div>
              </div>
              <div className="v2_pop_info_section1_list_holder">
                <h2>{this.state.card_content ? this.state.card_content["subt2"] : ""}</h2>
                <hr />
                <div className="v2_pop_info_section1_list">

                  {this.state.card_content ? this.state.card_content["subl2"].map(item => 

                    <div className="v2_pop_info_section1_list_item">
                      <span className="v2_cube"></span>
                      <p>{item}</p>
                    </div>)

                   : <></>}
                  
                </div>
              </div>
            </div>
          </div>
          <div className="v2_solution_pop_up_card_info_section2">
            <div className="v2_solution_pop_up_card_main_info">
              <h3>{this.state.card_content ? this.state.card_content["subt3"] : ""}</h3>
              <p dangerouslySetInnerHTML={{ __html: this.state.card_content ? this.state.card_content["subc3"] : "" }}></p>
              <br/>
              <h3>{this.state.card_content ? this.state.card_content["subt4"] : ""}</h3>
              <p dangerouslySetInnerHTML={{ __html: this.state.card_content ? this.state.card_content["subc4"] : "" }}></p>
            </div>
            {/*<div className="v2_solution_pop_up_card_btn_section"></div>*/}
            <button className="v2_solution_pop_up_card_close" onClick={() => this.props.update_card_status("close")}>x</button>
          </div>
        </div>
      </div>
    )
  }
}

export default SolutionPage;













